import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { DiliTextCP } from "../Utility/DiliTextCP";
import { format as dateFormat, add as dateAdd, formatISO } from "date-fns";
// import {
//   BsArrow90DegRight,
//   BsArrowRightCircle,
//   BsGripVertical,
//   BsX,
// } from "react-icons/bs";
// import {
//   cloneDeep,
//   // debounce
//   // shuffle
// } from "lodash";
// import { OverlayTrigger } from "react-bootstrap";
// import { TooltipStandard } from "../Utility/TooltipStandard";
import { TooltipMouseTrack } from "../Utility/TooltipMouseTrack";
import {
  closestCenter,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  // useDraggable,
  useDroppable,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { XIcon } from "../Utility/Icons/XIcon";
import { toast } from "react-toastify";
import { MoreDetailsIcon } from "../Utility/Icons/MoreDetailsIcon";
import { IconButton } from "../Utility/Icons/IconButton";
import {
  // MdClear,
  // MdHighlightOff,
  MdOutlineArrowCircleRight,
  MdRefresh,
  // MdOutlineSettings,
  // MdOutlineArrowRight,
} from "react-icons/md";
import { DedicatedOrderDetails } from "./DedicatedOrderDetails";
import axios from "axios";
import { DiliMap } from "./Maps/DiliMap";
import {
  // CDKRawDataFieldsToHide,
  generateCDKDestinationInfo,
  localStorageVariables,
  orderAndPositionTerminologyOptions,
  viewStates,
} from "../../constants";
import { EditCDKDispatchDestinationModal } from "./EditCDKDispatchDestinationModal";
import { BsPencilSquare, BsThreeDotsVertical } from "react-icons/bs";
import handleApiError from "../../helpers/handleApiError";
import {
  getGeoCoordinatesForAddress,
  getMapApiKey,
  getMapRouteEP,
  getPositions,
  modifyOrdersForPosition,
  printManifestForPosition,
  submitOrdersForPosition,
  UpdateCdkOrderInformation,
} from "../../services/cdkDedicatedDispatchService";
import {
  getClientLocation,
  isDemoAccountFunc,
  isReadOnly,
} from "../../services/accountService";
// import { BiSolidPackage } from "react-icons/bi";
import {
  PiHouseFill,
  PiMapPinAreaFill,
  PiPackage,
  PiPersonSimpleBike,
} from "react-icons/pi";
import {
  convertMetersToMiles,
  convertSecondsIntoHoursMinutesSeconds,
  dateZeroTime,
  generateLocationKey,
  generateLocationString,
  randomFloatBetween,
} from "../../helpers/utilities";
import { AddManualDedicatedStopModal } from "./AddManualDedicatedStopModal";
// import { CollapsibleUITest } from "./CollapsibleUITest";
import { Dropdown, OverlayTrigger } from "react-bootstrap";
import { ToggleSwitch } from "../Utility/FormElements/ToggleSwitch";
import { CollapseButton } from "./CollapseButton";
import {
  collapsedStatePanelSizes,
  collapsedStates,
  CXTStopTypes,
  dedicatedOrderStatuses,
  determineDedicatedOrderStatus,
  dispatchErrorMessages,
  glyphTypes,
} from "./DedicatedDispatchConstants";
import useDebounceEffect from "../../hooks/useDebounceEffect";
import { TooltipStandard } from "../Utility/TooltipStandard";
import { DedicatedOrderStatusIndicator } from "./DedicatedOrderStatusIndicator";
import { getCdkOrders } from "../../services/cdkOrderService";
// import { TiClipboard } from "react-icons/ti";
import fileDownload from "js-file-download";
import { CustomDropdownToggle } from "../Utility/ReactBootstrapHelpers/CustomDropdownToggle";
import LoadingSpinner from "../LoadingSpinner";
import SwitchingDriverConfirmationModal from "./SwitchingDriverConfirmationModal";
import Checkbox from "../Checkbox";
import useLocalStorage from "../../hooks/useLocalStorage";
import { useQueries } from "@tanstack/react-query";
import { HelmetUtil } from "../Utility/HelmetUtil";
import useDecodeToken from "../../hooks/useDecodeToken";
// import { CollapsibleUITestWithContent } from "./CollapsibleUITestWithContent";

// const mapsApiAxios = axios.create();
// let renderCount = 0;

//How reactively we want the app to update routes
// const reactivityLevels = {
//   onDrag: "onDrag", //Update on drag. Will update the route as user is dragging. This will end up costing a lot more, however it is debounced to reduce cost.
//   onDrop: "onDrop", //Update on drop. Only update the route once the user as dropped the item.
//   onClickRoute: "onClickRoute", //Update on button click. User will have to click a button to manually fetch the routes. Most cost effective.
// };
// //We could store this on the back end or do it per client (maybe charge them differently) and get it based on this but for now just have it
// //set to this across the board.
// const reactivityLevel = reactivityLevels.onDrop;

/**
 *
 * @param {{legs:
 * [
 * {
 * duration:string,
 * distanceMeters:number,
 * }
 * ]
 * }} route
 * Expects route in the formate google sends or at least an object with a legs array, each leg having a duration and distance field.
 *
 * Expects duration field to be a string with an "s" or any extra letter at the end, as it will cut the last letter off.
 */
const getRouteTotalDurationAndDistance = (route) => {
  //add 20 minutes to duration per intermediate stop
  const timeAtStopInSeconds = 20 * 60;
  if (!route) {
    return {
      duration: {
        hours: 0,
        minutes: 0,
      },
      distance: 0,
    };
  }
  // console.log("route totals param - ", route);
  const totalDurationAndDistance = route?.legs?.reduce(
    (totalBuilder, leg, index) => {
      return {
        duration:
          totalBuilder.duration +
          Number(leg.duration.slice(0, -1)) +
          (index !== route?.legs?.length - 1 ? timeAtStopInSeconds : 0), //add time for each stop (excluding the last one as that is back at the client location)
        distance: totalBuilder.distance + (leg.distanceMeters ?? 0),
      };
    },
    {
      duration: 0,
      distance: 0,
    },
  );
  // console.log("route total - seconds", totalDurationAndDistance.duration);
  return {
    duration: convertSecondsIntoHoursMinutesSeconds(
      totalDurationAndDistance.duration,
      true,
    ),
    distance: convertMetersToMiles(totalDurationAndDistance.distance).toFixed(
      2,
    ),
  };
  // positionMapCache?.[
  //   selectedPositionID
  // ]?.route?.legs?.reduce((totalTime, leg) => {
  //   const currentTotalTime =
  //     totalTime + +leg.duration.slice(0, -1);
  //   console.log("Time Test - leg time", leg.duration);
  //   console.log(
  //     "Time test - CURRENT TOTAL TIME",
  //     currentTotalTime
  //   );
  //   return currentTotalTime;
  // }, 0) / 60
};

const generateIndexToPhysicalStopNumberMap = (stopsWithLocationStrings) => {
  // console.log("stops with location strings", stopsWithLocationStrings);
  let physicalStopNumberDictionaryTemp = {};
  let physicalStopCounter = 1;
  let nextStop;
  for (let i = 0; i < stopsWithLocationStrings?.length; i++) {
    if (i < stopsWithLocationStrings.length - 1) {
      nextStop = stopsWithLocationStrings[i + 1];
    }
    if (
      nextStop?.locationString === stopsWithLocationStrings[i].locationString
    ) {
      physicalStopNumberDictionaryTemp[i] = physicalStopCounter;
    } else {
      physicalStopNumberDictionaryTemp[i] = physicalStopCounter;
      physicalStopCounter++;
    }
  }
  return physicalStopNumberDictionaryTemp;
};

//OR we can check the isManual field if passing the entire stop instead.
//This is used to set the isDraggingManualOrder field on draggingData. You should try using that first.
const isManualStopBasedOnId = (stopId) => {
  return stopId.startsWith("Manual");
};

const attemptedToDragBetweenCompletedOrNextUp = (dndEvent) => {
  const overItemData = dndEvent.over?.data?.current;
  return (
    overItemData.status === dedicatedOrderStatuses.completed ||
    overItemData.nextUp
  );
};

const draggableTypes = {
  order: "order",
  stop: "stop",
};
const dropTypes = {
  ordersDropzone: "ordersDropZone",
  stopsDropzone: "stopsDropzone",
  driverDirectDrop: "driverDirectDrop",
  disabled: "disabledDropzone",
};

const DispatchBoardHeader = ({ title, headerContent, children }) => {
  return (
    <div className="p-3 border-bottom">
      <div className="d-flex justify-content-between align-items-start">
        <h4>{title}</h4>
        {headerContent}
      </div>
      {children}
    </div>
  );
};

const DropZone = ({
  id,
  children,
  isDisabledVisual,
  isDisabledVisualRed,
  forwardProps,
  data,
  disabled,
  style,
  ...props
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id: id,
    data: data,
    disabled: disabled,
  });
  const proppedChildren = React.cloneElement(children, {
    isOver: isOver,
    isDisabledVisualRed: isDisabledVisualRed,
  });
  return (
    <div
      ref={setNodeRef}
      {...props}
      style={{
        position: "relative",
        ...style,
      }}
    >
      <div
        style={{
          pointerEvents: "none",
          position: "absolute",
          inset: 0,
          transitionDuration: ".2s",
          // backgroundColor: isOver && isDisabledVisualRed ? "red" : null,
          boxShadow:
            isOver && !isDisabledVisual
              ? "0px 0px 0px 3px rgb(50,200,230) inset"
              : "",
        }}
      ></div>
      {forwardProps ? proppedChildren : children}
      {/* {children} */}
    </div>
  );
};
const orderDateFilterOptions = {
  today: { display: "Today", value: "today" },
  last24Hours: { display: "Last 24 Hours", value: "last24Hours" },
  last3Days: { display: "Last 3 Days", value: "last3Days" },
  // last7Days: { display: "Last 5 Days", value: "last5Days" },
};
const OrdersDropzoneAndHeader = ({
  onOrderMouseEnter,
  onOrderMouseLeave,
  orderTerminology,
  orders,
  readOnly,
  position,
  orderOnClick,
  onAssignOrderClick,
  onDetailsClick,
  onEditDestinationClick,
  orderOnMouseEnter,
  orderOnMouseLeave,
  isOver,
  draggingData,
  selectedOrderIDs,
  refetchOrders,
  isLoadingOrders,
  failedGeolocationsLookupObj,
  completeNextOrderTestFunction,
  ...rest
}) => {
  const [decodedToken] = useDecodeToken();
  const orderTermLowerCase = orderTerminology?.toLowerCase();
  const [isRefetchingOrders, setIsRefetchingOrders] = useState(false);
  const [orderFilter, setOrderFilter] = useState("");
  const handleChangeOrderFilter = (e) => {
    setOrderFilter(e.target.value);
  };
  const [orderDateFilter, setOrderDateFilter] = useState(
    orderDateFilterOptions.last3Days.value,
  );
  const handleChangeOrderDateFilter = (e) => {
    setOrderDateFilter(e.target.value);
  };
  const [sortByField, setSortByField] = useState("dateTimeAdded");
  const handleChangeSortByField = (e) => {
    setSortByField(e.target.value);
  };
  const [sortByDesc, setSortByDesc] = useState(true);
  const handleToggleSortByDesc = (value) => {
    if (sortByDesc !== value) {
      setSortByDesc(value);
    }
  };
  let referenceDate;
  if (orderDateFilter === orderDateFilterOptions.today.value) {
    referenceDate = formatISO(dateAdd(todayNoTime, { seconds: -1 }));
  } else if (orderDateFilter === orderDateFilterOptions.last24Hours.value) {
    referenceDate = formatISO(dateAdd(today, { days: -1 }));
  } else if (orderDateFilter === orderDateFilterOptions.last3Days.value) {
    referenceDate = formatISO(dateAdd(today, { days: -3 }));
  }
  // For testing
  //  else if (orderDateFilter === orderDateFilterOptions.last7Days.value) {
  //   referenceDate = formatISO(dateAdd(today, { days: -5 }));
  // }

  const filterValue = orderFilter.trim().toLowerCase();
  const filteredOrders = orders
    .filter((order) => {
      // console.log(Object.values(order).join(" "));
      // console.log("order date time added", order.dateTimeAdded);
      // console.warn("reference date", referenceDate);
      // console.log(
      //   "date time added > reference Date",
      //   order?.dateTimeAdded > referenceDate
      // );
      return (
        !order.hidden &&
        !order.isManual &&
        (order.invoiceNumber?.toLowerCase()?.includes(filterValue) ||
          order.customerName?.toLowerCase()?.includes(filterValue) ||
          order.customerName2?.toLowerCase()?.includes(filterValue) ||
          order.address?.toLowerCase()?.includes(filterValue) ||
          order.city?.toLowerCase()?.includes(filterValue) ||
          order.state?.toLowerCase()?.includes(filterValue) ||
          order.zip?.toLowerCase()?.includes(filterValue) ||
          order.suite?.toLowerCase()?.includes(filterValue)) &&
        order?.dateTimeAdded >= referenceDate
      );
    })
    .sort((a, b) => {
      if (
        sortByField === "invoiceNumber" &&
        !isNaN(parseInt(a[sortByField])) &&
        !isNaN(parseInt(b[sortByField]))
      ) {
        const aInt = parseInt(a[sortByField]);
        const bInt = parseInt(b[sortByField]);
        return sortByDesc ? bInt - aInt : aInt - bInt;
      } else {
        return sortByDesc
          ? b[sortByField]?.localeCompare(a[sortByField])
          : a[sortByField]?.localeCompare(b[sortByField]);
      }
    });

  const handleRefetchOrders = async () => {
    try {
      setIsRefetchingOrders(true);
      await refetchOrders();
      setIsRefetchingOrders(false);
    } catch (ex) {
      // handleApiError(ex); //error should be handled in refetch orders function
      setIsRefetchingOrders(false);
    }
  };
  //Quick Entry
  const handleQuickEntry = (e) => {
    if (e.key === "Enter") {
      if (filteredOrders.length > 1) {
        toast.error("Quick entry not allowed for multiple results.");
        return;
      }
      if (filteredOrders.length === 0) {
        toast.error(`No ${orderTermLowerCase}s found for quick entry.`);
        return;
      }
      //if only 1 filtered order result
      onAssignOrderClick(e, filteredOrders[0]);
    } else if (e.ctrlKey && e.key === "q") {
      if (decodedToken.ClientId === 22622) {
        completeNextOrderTestFunction();
      }
    }
  };
  return (
    <>
      <DispatchBoardHeader
        title={orderTerminology + "s"}
        headerContent={
          <div>
            {/* <IconButton
              icon={<MdRefresh />}
              buttonClassAppend={"d-inline-block"}
              small
            /> */}
            {isRefetchingOrders ? (
              <LoadingSpinner
                size={20}
                alt="Refetching orders"
                title="Refetching orders"
              />
            ) : (
              <MdRefresh
                className="d-inline-block tw-cursor-pointer"
                size={25}
                alt="Refetch Orders"
                title="Refetch Orders"
                onClick={handleRefetchOrders}
              />
            )}
            <Dropdown className="d-inline-block">
              <Dropdown.Toggle as={CustomDropdownToggle} id="order-actions">
                <BsThreeDotsVertical
                  size={25}
                  className="tw-cursor-pointer"
                  style={{ marginRight: "-5px" }}
                />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <div className="px-3 pb-2">
                  <div>Show orders for</div>
                  <DiliTextCP
                    type="select"
                    style={{ minWidth: "200px" }}
                    onChange={handleChangeOrderDateFilter}
                    value={orderDateFilter}
                  >
                    <option value={orderDateFilterOptions.today.value}>
                      {orderDateFilterOptions.today.display}
                    </option>
                    <option value={orderDateFilterOptions.last24Hours.value}>
                      {orderDateFilterOptions.last24Hours.display}
                    </option>
                    <option value={orderDateFilterOptions.last3Days.value}>
                      {orderDateFilterOptions.last3Days.display}
                    </option>
                    {/* <option value={orderDateFilterOptions.last7Days.value}>
                      {orderDateFilterOptions.last7Days.display}
                    </option> */}
                  </DiliTextCP>
                  <div className="mt-2 d-flex justify-content-between align-items-center">
                    Sort By
                    <div
                      className="btn-group font-600 text-note mb-2"
                      style={{
                        borderRadius: ".25rem",
                        boxShadow: "0px 0px 3px rgb(0,0,0,.2)",
                      }}
                    >
                      <button
                        type="button"
                        className={
                          "btn btn-small" +
                          (!sortByDesc ? " btn-group-btn-active" : "")
                        }
                        onClick={() => {
                          handleToggleSortByDesc(false);
                        }}
                      >
                        Asc
                        {/* <BsCardList /> */}
                      </button>

                      <button
                        type="button"
                        className={
                          "btn btn-small" +
                          (sortByDesc ? " btn-group-btn-active" : "")
                        }
                        onClick={() => {
                          handleToggleSortByDesc(true);
                        }}
                      >
                        Desc
                        {/* <BsList /> */}
                      </button>
                    </div>
                  </div>
                  <DiliTextCP type="select" onChange={handleChangeSortByField}>
                    <option value="dateTimeAdded">Imported Date</option>
                    <option value="customerName">Customer Name</option>
                    <option value="invoiceNumber">Invoice</option>
                  </DiliTextCP>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        }
      >
        <DiliTextCP
          name="orderSearch"
          placeholder={`Filter ${filteredOrders.length} orders...`}
          onChange={handleChangeOrderFilter}
          onKeyDown={handleQuickEntry}
        />
      </DispatchBoardHeader>
      <div className="tw-overflow-auto flex-fill">
        {filteredOrders.length > 0 ? (
          <>
            {/* No point in sorting orders? Maybe just temporarily to make it easier for a user to work with? */}
            {/* <SortableContext
          items={orders.map((order) => order?.deliveryId)}
          strategy={verticalListSortingStrategy}
        > */}
            {filteredOrders.map((order, index) => {
              return (
                <Order
                  key={order?.deliveryId}
                  order={order}
                  readOnly={readOnly}
                  selectedOrderIDs={selectedOrderIDs}
                  draggingData={draggingData}
                  onClick={(e) => {
                    orderOnClick(e, order);
                  }}
                  onAssignOrderClick={(e) => {
                    onAssignOrderClick(e, order);
                  }}
                  onDetailsClick={onDetailsClick}
                  onEditDestinationClick={onEditDestinationClick}
                  onMouseEnter={onOrderMouseEnter}
                  onMouseLeave={onOrderMouseLeave}
                  position={position}
                  failedGeolocationsLookupObj={failedGeolocationsLookupObj}
                />
              );
            })}
            <DropZone
              id={dropTypes.ordersDropzone}
              // style={{ height: "20px" }}
              data={{ dropType: dropTypes.ordersDropzone }}
              isDisabledVisual
            >
              <div className="tw-grid tw-place-content-center tw-flex-1 tw-text-center font-600 text-note h-100">
                {isOver ? "Drop to unassign stop" : ""}
              </div>
            </DropZone>
            {/* </SortableContext> */}
          </>
        ) : (
          <DropZone
            id={dropTypes.ordersDropzone}
            data={{ dropType: dropTypes.ordersDropzone }}
            disabled={isLoadingOrders}
            // className="tw-overflow-auto flex-fill"
            style={{
              width: "100%",
              height: "100%",
              placeContent: "center",
              fontWeight: 600,
            }}
          >
            <div className="text-note h5 mb-0 text-center">
              <span className="h5">
                {
                  isLoadingOrders
                    ? `Loading ${orderTerminology}s`
                    : isOver
                      ? "Drop to unassign stop"
                      : `No ${orderTermLowerCase}s found` // I guess if no orders were found, they wouldn't be able to unassign a stop anyway?
                }
              </span>
            </div>
          </DropZone>
        )}
      </div>
    </>
  );
};
const PositionDropzoneAndHeader = ({
  positionTerminology = "Position",
  positions,
  selectedPositionID,
  handleSelectPositionID,
  handlePrintManifestClick,
  draggingData,
  disabled,
  switchDriverCache,
  isLoadingPositions,
}) => {
  const positionTermLowerCase = positionTerminology?.toLowerCase();
  const [showInactive, setShowInactive] = useLocalStorage({
    key: localStorageVariables.dedicatedShowInactivePositions,
    initialValue: true,
  });
  const handleToggleShowInactive = (e) => {
    setShowInactive(e.target.checked);
  };
  const [positionFilter, setPositionFilter] = useState("");
  const handleChangePositionFilter = (e) => {
    setPositionFilter(e.target.value);
  };
  const [sortByField, setSortByField] = useLocalStorage({
    key: localStorageVariables.dedicatedPositionSortByField,
    initialValue: "positionName",
  });
  const handleChangeSortByField = (e) => {
    setSortByField(e.target.value);
  };
  const [sortByDesc, setSortByDesc] = useLocalStorage({
    key: localStorageVariables.dedicatedPositionSortByDesc,
    initialValue: false,
  });
  const handleToggleSortByDesc = (value) => {
    if (sortByDesc !== value) {
      setSortByDesc(value);
    }
  };
  const filterValue = positionFilter.trim().toLowerCase();
  const filteredPositions = positions
    .filter((position) => {
      return (
        (position.positionName.toLowerCase().includes(filterValue) ||
          position.driverName.toLowerCase().includes(filterValue)) &&
        (showInactive || determinePositionRunsOnCurrentDay(position))
      );
    })
    .sort((a, b) => {
      return sortByDesc
        ? b[sortByField]?.localeCompare(a[sortByField])
        : a[sortByField]?.localeCompare(b[sortByField]);
    });

  return (
    <>
      <DispatchBoardHeader
        title={positionTerminology + "s"}
        headerContent={
          <Dropdown className="d-inline-block">
            <Dropdown.Toggle as={CustomDropdownToggle} id="order-actions">
              <BsThreeDotsVertical
                size={25}
                className="tw-cursor-pointer"
                style={{ marginRight: "-5px" }}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <div className="px-3 pb-2" style={{ minWidth: "200px" }}>
                <Checkbox
                  name="Show Inactive"
                  label="Show Inactive"
                  checked={showInactive}
                  onChange={handleToggleShowInactive}
                ></Checkbox>
                <div className="mt-2 d-flex justify-content-between align-items-center">
                  Sort By
                  <div
                    className="btn-group font-600 text-note mb-2"
                    style={{
                      borderRadius: ".25rem",
                      boxShadow: "0px 0px 3px rgb(0,0,0,.2)",
                    }}
                  >
                    <button
                      type="button"
                      className={
                        "btn btn-small" +
                        (!sortByDesc ? " btn-group-btn-active" : "")
                      }
                      onClick={() => {
                        handleToggleSortByDesc(false);
                      }}
                    >
                      Asc
                      {/* <BsCardList /> */}
                    </button>

                    <button
                      type="button"
                      className={
                        "btn btn-small" +
                        (sortByDesc ? " btn-group-btn-active" : "")
                      }
                      onClick={() => {
                        handleToggleSortByDesc(true);
                      }}
                    >
                      Desc
                      {/* <BsList /> */}
                    </button>
                  </div>
                </div>
                <DiliTextCP
                  type="select"
                  value={sortByField}
                  onChange={handleChangeSortByField}
                >
                  <option value="">Creation Date</option>
                  <option value="positionName">
                    {positionTerminology} Name
                  </option>
                  <option value="driverName">Driver Name</option>
                </DiliTextCP>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        }
      >
        <DiliTextCP
          name="driverSearch"
          placeholder={`Filter ${positions?.length} ${positionTermLowerCase}s...`}
          value={positionFilter}
          onChange={handleChangePositionFilter}
        />
      </DispatchBoardHeader>
      {
        <div className="tw-overflow-auto flex-fill">
          {filteredPositions?.length > 0 ? (
            filteredPositions.map((position) => {
              return (
                <DropZone
                  key={position.positionID}
                  id={position.positionID}
                  data={{
                    dropType: dropTypes.driverDirectDrop,
                    active: determinePositionRunsOnCurrentDay(position),
                  }}
                  isDisabledVisual={
                    !determinePositionRunsOnCurrentDay(position)
                  }
                  isDisabledVisualRed={
                    !determinePositionRunsOnCurrentDay(position)
                  }
                  forwardProps
                  disabled={
                    disabled
                    // || draggingData.assignedTo === position.positionID //this prevents them from dragging an order onto the same position again. I don't like how it feels and previously I let them do it but with the new pseudo-event system I would need to add a new dropcase and then it could possibly lead to redundant calls (when they drag and drop an order on the same horizontal level as the position (not sure what I meant by this anymore)). Eventually when we have a better algorithm for determining if we need to even update the map based on what changed instead, might remove this. //Seemed fine in the current state after testing, didn't see any redundant calls
                  }
                  // disabled={!determineDriverWorksOnCurrentDay(driver)}
                >
                  <Driver
                    position={position}
                    isSelected={position.positionID === selectedPositionID}
                    onClick={() => {
                      handleSelectPositionID(position.positionID);
                    }}
                    handlePrintManifestClick={handlePrintManifestClick}
                    switchDriverCache={switchDriverCache}
                  />
                </DropZone>
              );
            })
          ) : (
            <div
              style={{
                display: "grid",
                width: "100%",
                height: "100%",
                placeContent: "center",
                fontWeight: 600,
              }}
              className="text-note h5 mb-0"
            >
              {isLoadingPositions
                ? `Loading ${positionTerminology}s`
                : `No ${positionTerminology}s Found`}
            </div>
          )}
        </div>
      }
    </>
  );
};
const StopsDropzone = ({
  positionTerminology,
  stops,
  readOnly,
  position,
  selectedPositionID,
  selectedOrderIDs,
  selectedPositionRunsToday,
  onEditDestinationClick,
  onStopMouseEnter,
  onStopMouseLeave,
  overlayRef,
  isOver,
  unAssignStop,
  onDetailsClick,
  handleShowAddStopManuallyModal,
  draggingData,
  switchDriverCache,
  completeStopTestFunction,
  indexToPhysicalStopNumberMap,
  latestCompletedOrderPhysicalStopNumber,
  ...rest
}) => {
  let positionTermLowerCase = positionTerminology?.toLowerCase();
  //moved to parent component because I needed it there to calculate route leg statuses and don't wanna do it twice.
  // const indexToPhysicalStopNumberMap = useMemo(() => {
  //   return generateIndexToPhysicalStopNumberMap(stops);
  // }, [stops, selectedPositionID]);

  return selectedPositionID ? (
    selectedPositionRunsToday ? (
      stops?.length > 0 ? (
        <>
          {/* <div>
  {
    drivers.find((driver) => driver.positionID === selectedPositionID)
      .name
  }
</div> */}

          <div className="tw-overflow-auto flex-fill">
            <SortableContext
              items={stops.map((stop) => stop?.deliveryId)}
              strategy={verticalListSortingStrategy}
            >
              {stops.map((stop, index) => {
                return (
                  <Order
                    key={stop?.deliveryId}
                    position={position}
                    readOnly={readOnly}
                    previousOrder={stops[index - 1]}
                    order={stop}
                    nextOrder={stops[index + 1]}
                    latestCompletedOrderPhysicalStopNumber={
                      latestCompletedOrderPhysicalStopNumber
                    }
                    stopNumber={index + 1}
                    physicalStopNumber={indexToPhysicalStopNumberMap[index]}
                    selectedOrderIDs={selectedOrderIDs}
                    handleUnassignStop={unAssignStop}
                    onDetailsClick={onDetailsClick}
                    onEditDestinationClick={onEditDestinationClick}
                    onMouseEnter={onStopMouseEnter}
                    onMouseLeave={onStopMouseLeave}
                    overlayRef={overlayRef}
                    draggingData={draggingData}
                    switchDriverCache={switchDriverCache}
                    completeStopTestFunction={completeStopTestFunction}
                    positionTerminology={positionTerminology}
                  />
                );
              })}
              {/* <div className="px-3 py-2">
                <div
                  role="button"
                  style={{
                    borderRadius: "12px",
                    border: "1px solid rgb(200,200,200)",
                    display: "grid",
                    placeContent: "center",
                    padding: "1.5rem",
                    textAlign: "center",
                    fontSize: "1.2rem",
                  }}
                  className="dispatch-board-add-stop-button text-note font-600"
                  onClick={handleShowAddStopManuallyModal}
                >
                  <div
                    style={{
                      fontSize: "50px",
                      lineHeight: "50px",
                      fontWeight: 300,
                    }}
                  >
                    +
                  </div>
                  Add Manual Stop
                </div>
              </div> */}
              <DropZone
                id={dropTypes.stopsDropzone}
                // style={{ height: "20px" }}
                data={{ dropType: dropTypes.stopsDropzone }}
                isDisabledVisual
              >
                <div className="tw-grid tw-place-content-center tw-flex-1 tw-text-center font-600 text-note h-100">
                  {isOver ? "Drop to assign stop" : ""}
                </div>
              </DropZone>
            </SortableContext>
          </div>
        </>
      ) : (
        <DropZone
          id={dropTypes.stopsDropzone}
          data={{ dropType: dropTypes.stopsDropzone }}
          className="tw-overflow-auto flex-fill"
          isDisabledVisual={!selectedPositionID}
        >
          <div className="tw-grid tw-place-content-center tw-flex-1 tw-text-center font-600 text-note h-100">
            <span className="h5">
              {isOver ? "Drop to assign stop" : "No stops assigned"}
            </span>
          </div>
        </DropZone>
      )
    ) : (
      <DropZone
        id={dropTypes.disabled} //having an active dropzone that just doesn't do any logic. This is because we use the closestCenter collision detection algorithm and if we don't do this, it will think we are trying to drop it onto a driver (closest dropzone) instead even when we are hovering in the stops section.
        //alternatively, we can change the DND collision detection algorithm to one that needs the draggable to be hovered INSIDE the dropzone but that may cause other issues or be slightly more janky, but I haven't tested.
        data={{ dropType: dropTypes.disabled }}
        className="tw-overflow-auto flex-fill"
        isDisabledVisual
      >
        <div className="tw-grid tw-place-content-center tw-flex-1 tw-text-center font-600 text-note h-100">
          <span className="h5 text-danger">
            This {positionTermLowerCase} does <br /> not run today
          </span>
        </div>
      </DropZone>
    )
  ) : (
    <DropZone
      id={dropTypes.disabled}
      data={{ dropType: dropTypes.disabled }}
      className="tw-overflow-auto flex-fill"
      isDisabledVisual
    >
      <div className="tw-grid tw-place-content-center tw-flex-1 tw-text-center font-600 text-note h-100">
        <span className="h5">
          Select a {positionTermLowerCase}
          <br /> to view its stops
        </span>
      </div>
    </DropZone>
  );
};

const Order = ({
  previousOrder,
  order,
  readOnly,
  nextOrder,
  latestCompletedOrderPhysicalStopNumber,
  position,
  stopNumber, // passing this will indicate that the order is an assigned stop instead.
  physicalStopNumber,
  handleUnassignStop,
  onAssignOrderClick,
  onDetailsClick,
  onEditDestinationClick,
  selectedOrderIDs,
  draggingData,
  isOverlay,
  onMouseEnter,
  onMouseLeave,
  overlayRef,
  reftest,
  styleAppend = {},
  classAppend = "",
  switchDriverCache,
  completeStopTestFunction,
  failedGeolocationsLookupObj,
  positionTerminology,
  ...rest
}) => {
  const isStop = stopNumber !== null && stopNumber !== undefined;
  const isRemovalDisabled =
    readOnly || (isStop && order.status !== dedicatedOrderStatuses.unSubmitted);
  const missedStop =
    !isOverlay &&
    order.status === dedicatedOrderStatuses.submitted && //if the order is submitted, but not complete, and the latest completed physical stop is after or is this one's physical stop number, mark it as incomplete/missed
    physicalStopNumber <= latestCompletedOrderPhysicalStopNumber;
  // const nextUp =
  //   !isOverlay &&
  //   order.status === dedicatedOrderStatuses.submitted &&
  //   (previousOrder?.status === dedicatedOrderStatuses.completed ||
  //     !previousOrder);
  const nextUp =
    !isOverlay &&
    order.status === dedicatedOrderStatuses.submitted &&
    physicalStopNumber === latestCompletedOrderPhysicalStopNumber + 1;
  //Changing order of stops is disabled for those that are completed or the next stop (stop before is completed)
  //Need to also account for other orders being added or moved between these
  const isChangingAssignmentOrderDisabled =
    readOnly ||
    (isStop
      ? order.status === dedicatedOrderStatuses.completed ||
        (nextUp && stopNumber !== 1) //If it is the first stop (i.e. driver departure isn't confirmed) let them change it *TODO need to change the logic for this eventually
      : false);
  const sequenceModified =
    !isOverlay &&
    isStop &&
    position?.wasSubmitted &&
    order.sequence &&
    order.sequence !== stopNumber;
  const fromAnotherDriver = useMemo(() => {
    return (
      isStop &&
      switchDriverCache?.[position.positionID]?.orders?.includes(
        order.deliveryId,
      )
    );
  }, [position, switchDriverCache]);
  const isModified = sequenceModified || fromAnotherDriver;
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    id: `${order?.deliveryId}${isOverlay ? "-overlay" : ""}`,
    data: {
      draggableType: isStop ? draggableTypes.stop : draggableTypes.order,
      assignedTo: order.assignedTo,
      status: order.status,
      nextUp: nextUp,
      stopNumber: stopNumber,
      physicalStopNumber: physicalStopNumber,
    },
    disabled: readOnly || isChangingAssignmentOrderDisabled,
  });
  // console.log("position", position);

  // console.log("selected order IDs", selectedOrderIDs);

  const style = {
    opacity:
      !isOverlay &&
      (isDragging ||
        (selectedOrderIDs?.length > 0 &&
          draggingData?.id !== null &&
          selectedOrderIDs.includes(order.deliveryId)))
        ? 0.5
        : 1,
    borderRadius: "5px",
    boxShadow: selectedOrderIDs.includes(order.deliveryId)
      ? "0px 0px 0px 2px cyan inset"
      : "",
    transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : "",
    transition,
    ...styleAppend,
  };
  const overlayStyle = isOverlay
    ? {
        position: "relative",
        backgroundColor: "white",
        // boxShadow: "0px 5px 10px 0px rgba(0,0,20,.3)", //moving to drag-overlay-inner-container class
        borderRadius: "5px", //keep this in sync with drag-overlay-inner-container class, better yet move to css
        cursor: "grabbing",
        // transform: transform
        //   ? `translate(${transform.x}px, ${transform.y}px)`
        //   : undefined,
        // transition: transition,
      }
    : {};

  const combinedStyle = { ...style, ...overlayStyle };
  // console.log("dragging data test", draggingData);
  return (
    <div
      onDoubleClick={onAssignOrderClick}
      ref={(e) => {
        setNodeRef(e);
        if (reftest) {
          reftest["current"] = e;
        }
      }}
      className={`px-3 border-bottom d-flex gap-4 no-copy drag-item${
        classAppend ? " " + classAppend : ""
      }${
        isOverlay
          ? " draggable-overlay-onMouseLeaveHelper"
          : " dispatch-board-hoverable"
      }`}
      style={combinedStyle}
      onMouseEnter={
        onMouseEnter && !draggingData?.id //if we are dragging right now, do not call the onMouseEnter function which sometimes gets called when dragging fast, causing the hovered marker to change to a different location when it shouldn't (the dragged item should always stayed as the "hovered/selected" marker)
          ? (e) => {
              // console.log("on mouse enter");
              onMouseEnter(e, order.locationKey);
            }
          : null
      }
      onMouseLeave={
        onMouseLeave && !draggingData?.id
          ? (e) => {
              // console.log('test\n\n"test\n');
              // console.log(e);
              // console.log(overlayRef);
              if (
                e.relatedTarget === overlayRef?.current ||
                overlayRef?.current?.contains(e.relatedTarget)
              ) {
                return;
              }
              onMouseLeave(e, null);
            }
          : null
      }
      {...rest}
      {...listeners}
      {...attributes}
    >
      {isOverlay && selectedOrderIDs.length > 0 && (
        <div>
          <div
            style={{
              borderRadius: "3000px",
              position: "absolute",
              top: "-1rem",
              right: "-1rem",
              backgroundColor: "blue",
              color: "white",
              width: "2.5rem",
              height: "2.5rem",
              fontSize: "1.5rem",
              display: "grid",
              placeContent: "center",
              textAlign: "center",
            }}
          >
            {selectedOrderIDs.length}
          </div>
        </div>
      )}
      {isStop && (
        <>
          {/* <div
            className="dragHandle"
            style={{ cursor: isOverlay ? "grabbing" : "grab" }}
          >
            <BsGripVertical />
          </div> */}
          <div
            className="d-flex flex-column"
            style={{
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                backgroundColor:
                  order.locationString === previousOrder?.locationString
                    ? "rgb(200,200,200)"
                    : "transparent",
                width: "15px",

                marginTop: "-1px",
                marginBottom: "-5px",
                flex: 1,
              }}
            ></div>
            <div
              style={{
                backgroundColor: "rgb(200,200,200)",
                height: "2.75rem",
                width: "2.75rem",
                minWidth: "2.75rem", //squishes without this on narrower screen sizes
                borderRadius: "100000px",
                display: "grid",
                placeContent: "center",
                fontWeight: "bold",
                fontSize: stopNumber > 99 ? "1.3rem" : "1.5rem",
                overflow: "hidden",
                color: "rgb(150,150,150)",
                userSelect: "none",
              }}
            >
              {/* <div style={{ transform: "translate(5px, 0px)" }}>{index}</div> */}
              {physicalStopNumber}
            </div>
            <div
              style={{
                backgroundColor:
                  order.locationString === nextOrder?.locationString
                    ? "rgb(200,200,200)"
                    : "transparent",
                width: "15px",
                marginTop: "-5px",
                marginBottom: "-1px",
                flex: 1,
              }}
            ></div>
          </div>
        </>
      )}
      <div className="py-2" style={{ width: "100%" }}>
        <div
          className="font-600"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            {order?.invoiceNumber}
            {isStop && (
              <DedicatedOrderStatusIndicator
                orderStatus={order?.status}
                nextUp={nextUp}
                missed={missedStop}
                positionPreviouslySubmitted={position?.wasSubmitted}
                isModified={isModified}
              />
            )}
          </div>
          <div
            className="dispatch-board-order-buttons-container"
            style={{ marginLeft: "auto" }}
          >
            {!readOnly && !stopNumber && (
              <IconButton
                small
                icon={
                  <BsPencilSquare
                    size={12}
                    style={{ transform: "scale(1.2)" }}
                  />
                }
                // customPadding=".15rem"
                buttonClassAppend="text-note"
                onClick={(e) => {
                  onEditDestinationClick(order);
                }}
              />
            )}

            <IconButton
              small
              icon={
                <MoreDetailsIcon
                  size={15}
                  style={{ transform: "scale(1.2)" }}
                />
              }
              // customPadding=".15rem"
              buttonClassAppend="text-note"
              onClick={(e) => {
                onDetailsClick(e, order);
              }}
            />

            {stopNumber
              ? // !isChangingAssignmentOrderDisabled && (
                !isRemovalDisabled && ( //Right now, we don't support removing orders after submission.
                  <>
                    {/* <IconButton
              icon={<XIcon />}
              buttonClassAppend="dispatch-board-x-button text-note"
            /> */}
                    <button
                      type="button"
                      className="dispatch-board-x-button"
                      onClick={() => {
                        handleUnassignStop(order.deliveryId, true);
                      }}
                    >
                      <XIcon />
                      {/* <BsX size={25} /> */}
                      {/* <MdClear /> */}
                    </button>
                  </>
                )
              : !readOnly && (
                  <IconButton
                    small
                    icon={
                      <MdOutlineArrowCircleRight
                        size={15}
                        style={{ transform: "scale(1.2)" }}
                      />
                    }
                    // customPadding=".15rem"
                    onClick={onAssignOrderClick}
                    onDoubleClick={(e) => {
                      //To prevent double click from bubbling up to the outer element's double click event. When double clicking the add button it would attempt to assign 3 times. First click, Second click, and then bubbled up double click on parent.
                      e.stopPropagation();
                    }}
                    buttonClassAppend="text-note"
                  />
                )}
          </div>
        </div>
        <div
          style={{
            fontSize: ".9rem",
            //This might work if we want to prevent line breaks, to keep more even heights
            // maxWidth: "10rem",
            // whiteSpace: "nowrap",
            // overflow: "hidden",
            // textOverflow: "ellipsis",
          }}
        >
          {order?.customerName}
        </div>
        <div style={{ fontSize: ".9rem" }}>{order?.address}</div>
        <div style={{ fontSize: ".9rem" }}>
          {order?.city}, {order?.state} {order?.zip}
        </div>
        <div>
          {/* {console.log(failedGeolocationsLookupObj)} */}
          {failedGeolocationsLookupObj?.[order.locationKey] ? (
            <span className="dedicated-dispatch-list-item-badge dedicated-dispatch-list-item-badge-error">
              Verify Address
            </span>
          ) : (
            ""
          )}
        </div>
        {/* {isStop && (
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              completeStopTestFunction(position.positionID, order.deliveryId);
            }}
          >
            Complete
          </button>
        )} */}
        {
          //isModified && //Currently adding the modified badge while reoordering orders causes the heights to change, causing the ResizedObserver loop error to occur often. If we switch to only updating the positions/stops state until on drag end, this might be ok.
          fromAnotherDriver && (
            <span
              style={{
                backgroundColor: "rgb(207, 158, 72)",
                borderRadius: "3px",
                color: "white",
                paddingLeft: ".5rem",
                paddingRight: ".6rem",
                paddingTop: ".1rem",
                paddingBottom: ".1rem",
                fontWeight: "600",
                fontSize: "12px",
              }}
            >
              {fromAnotherDriver
                ? `Switching ${positionTerminology}`
                : "Modified"}
            </span>
          )
        }
        {/* <div>{isStop ? `${order.sequence} - ${stopNumber}` : ""}</div> */}
      </div>
    </div>
  );
};

const today = new Date();
const todayNoTime = dateZeroTime(today);
const todayString = dateFormat(today, "yyyy-MM-dd");
// const convertFreqStringToDayBooleans = (freqString) => {
//   return freqString.map((letter) => {
//     return letter === "Y";
//   });
// };
const days = ["M", "T", "W", "Th", "F", "Sa", "Su"];
// const Driver = ({ driver, isSelected, ...rest }) => {
//   return (
//     <div
//       className={`p-3 border-bottom dispatch-board-driver ${
//         isSelected ? "dispatch-board-driver-selected" : ""
//       }`}
//       {...rest}
//     >
//       <div className="d-flex align-items-start justify-content-between">
//         <h5>{driver.position}</h5>
//         <TooltipMouseTrack
//           message={
//             <div
//               style={{ display: "flex", alignItems: "center", gap: ".3rem" }}
//             >
//               {days.map((day, index) => {
//                 return (
//                   <>
//                     <div
//                       style={{
//                         display: "grid",
//                         placeContent: "center",
//                         width: "1.2rem",
//                         fontSize: ".7rem",
//                         backgroundColor:
//                           driver.frequency[index] === "Y"
//                             ? "rgb(0,150,0)"
//                             : "rgb(230,230,230)",
//                         color:
//                           driver.frequency[index] === "Y" ? "white" : "blacK",
//                         borderRadius: "3px",
//                         padding: "0rem .2rem 0rem .2rem",
//                       }}
//                     >
//                       {day}
//                     </div>

//                     {/* {index !== 6 && (
//                                 <div
//                                   style={{
//                                     backgroundColor: "rgb(230,230,230)",
//                                     width: "7px",
//                                     height: "5px",
//                                   }}
//                                 ></div>
//                               )} */}
//                   </>
//                 );
//               })}
//             </div>
//           }
//         >
//           <div
//             style={{
//               width: "1.2rem",
//               height: "1.2rem",
//               // backgroundColor: "red",
//               display: "grid",
//               placeContent: "center",
//             }}
//           >
//             <div
//               style={{
//                 backgroundColor: "rgba(0,150,0)",
//                 borderRadius: "10000px",
//                 width: ".75rem",
//                 height: ".75rem",
//               }}
//             ></div>
//           </div>
//         </TooltipMouseTrack>
//       </div>
//       <div>{driver.name}</div>
//     </div>
//   );
// };

const determinePositionRunsOnCurrentDay = (position) => {
  // return true;
  //subtracting 1 and using at because our frequency string starts on monday but getDay is based on sunday being 0
  //so getDay returns 1 for monday, and the frequency string's monday value is at index 0, so subtract 1
  //sunday will be the last index in the string but getDay - 1 will for sunday will return -1
  //using at let's us use -1 to get the last element in the string, sunday
  return position?.frequency?.at(today.getDay() - 1) === "Y";
};

const Driver = ({
  position,
  isSelected,
  onClick,
  isOver,
  isDisabledVisualRed,
  handlePrintManifestClick,
  switchDriverCache,
  ...rest
}) => {
  const worksToday = determinePositionRunsOnCurrentDay(position);
  const numSubmittedStopsFromAnyDriver = useMemo(() => {
    return position.stops.filter(
      (stop) => stop.status !== dedicatedOrderStatuses.unSubmitted,
    ).length;
  }, [position]);
  const submittedOrdersFromAnotherDriver = useMemo(() => {
    return switchDriverCache[position.positionID]?.orders?.length ?? 0;
  }, [position, switchDriverCache]);
  const numSubmittedStops =
    numSubmittedStopsFromAnyDriver - submittedOrdersFromAnotherDriver;
  // const completedStopsCount = position?.stops?.filter((stop) => {
  //   return stop.status === dedicatedOrderStatuses.completed;
  // })?.length;
  // const statusCounts = position?.stops?.reduce(
  //   (statusCountsBuilder, currentStop) => {
  //     if (currentStop.status === dedicatedOrderStatuses.unSubmitted) {
  //       statusCountsBuilder.unSubmitted++;
  //     }
  //     if (currentStop.status === dedicatedOrderStatuses.submitted) {
  //       statusCountsBuilder.unSubmitted++;
  //     }
  //     if (currentStop.status === dedicatedOrderStatuses.completed) {
  //       statusCountsBuilder.unSubmitted++;
  //     }
  //   },
  //   {
  //     unSubmitted: 0,
  //     submitted: 0,
  //     completed: 0,
  //   }
  // );
  return (
    <div
      className={`p-3 border-bottom dispatch-board-driver ${
        isSelected ? "dispatch-board-driver-selected" : ""
      }`}
      style={{
        backgroundColor:
          isOver && isDisabledVisualRed ? "rgb(175,175,175" : null,
        // color: isOver && isDisabledVisualRed ? "white" : null,
      }}
      onClick={() => {
        // worksToday
        onClick();
        // : toast.error("This position does not run today.");
      }}
      {...rest}
    >
      <div className="d-flex align-items-start">
        <h6>{position.positionName}</h6>
        {/* {position.wasSubmitted && (
          <IconButton
            small
            style={{ marginTop: "-7px" }}
            icon={
              <TiClipboard
                role="button"
                className="no-copy order-history-form-icon"
                title="Print Manifest"
                size={12}
                style={{ transform: "scale(1.3)" }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handlePrintManifestClick(e, position); //commenting out for now as we don't have the distance and time info until after they click into position after page reload. Could alternatively, on this event, check if that info is available, if not get it first and then print the manifest.
                }}
              />
            }
            // customPadding=".15rem"
            buttonClassAppend="text-note"
          />
        )} */}
        <TooltipMouseTrack
          containerClass="ml-auto"
          duration={1000000}
          message={
            <div
              style={{ display: "flex", alignItems: "center", gap: ".3rem" }}
            >
              {days.map((day, index) => {
                return (
                  <div
                    key={day}
                    style={{
                      display: "grid",
                      placeContent: "center",
                      width: "1.2rem",
                      fontSize: ".7rem",
                      backgroundColor:
                        position.frequency[index] === "Y"
                          ? "rgb(0,150,0)"
                          : "rgb(230,230,230)",
                      color:
                        position.frequency[index] === "Y" ? "white" : "blacK",
                      borderRadius: "3px",
                      padding: "0rem .2rem 0rem .2rem",
                    }}
                  >
                    {day}
                  </div>
                );
              })}
            </div>
          }
        >
          <div
            style={{
              width: "1.2rem",
              height: "1.2rem",
              // backgroundColor: "red",
              display: "grid",
              placeContent: "center",
            }}
          >
            <div
              style={{
                backgroundColor: worksToday
                  ? "rgba(0,150,0)"
                  : "rgb(150,150,150)",
                borderRadius: "10000px",
                width: ".75rem",
                height: ".75rem",
              }}
            ></div>
          </div>
        </TooltipMouseTrack>
      </div>
      <div>{position.driverName}</div>
      <div
        style={{
          fontSize: ".9rem",
          color: "rgb(100,100,100)",
          display: "flex",
          justifyContent: numSubmittedStops > 0 ? "end" : "start",
        }}
      >
        {/* {console.log("unsubmitted error incorrect - all stops", position.stops)}
        {console.log(
          "unsubmitted error incorrect - num submitted",
          numSubmittedStops
        )} */}

        {numSubmittedStops > 0 ? (
          numSubmittedStops === position.stops.length ? (
            <span
              style={{
                backgroundColor: "green",
                borderRadius: "3px",
                color: "white",
                paddingLeft: ".5rem",
                paddingRight: ".6rem",
                paddingTop: ".1rem",
                paddingBottom: ".1rem",
                fontWeight: "600",
                fontSize: "12px",
              }}
            >
              {numSubmittedStops} Submitted
            </span>
          ) : (
            <span
              style={{
                backgroundColor: "red",
                borderRadius: "3px",
                color: "white",
                paddingLeft: ".5rem",
                paddingRight: ".6rem",
                paddingTop: ".1rem",
                paddingBottom: ".1rem",
                fontWeight: "600",
                fontSize: "12px",
              }}
            >
              {numSubmittedStops}/{position.stops.length} Submitted
            </span>
          )
        ) : (
          `${position.stops.length} Assigned`
        )}
      </div>
    </div>
  );
};

const dummyPositions = [
  {
    ctposid: 37423,
    posname: "Daily - West",
    drvid: 0,
    freq: "YYYYYYY",
    fullname: "Jake Mulligan",
  },
  {
    ctposid: 40243,
    posname: "Daily - East",
    drvid: 1,
    freq: "YYYYYYY",
    fullname: "Jonathan Gonzales",
  },
  {
    ctposid: 40244,
    posname: "Downtown Run",
    drvid: 2,
    freq: "YYYYYNN",
    fullname: "Sebastian Finigo",
  },
  {
    ctposid: 40247,
    posname: "Weekly - Walmart Dropoffs",
    drvid: 3,
    freq: "NNNNYNN",
    fullname: "James Becken",
  },
];
const dummyOrders = [
  {
    id: 106532,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "14085 Northwest Fwy",
    customerCSZ: "Houston TX 77040",
    customerName: "The Home Depot - NW Fwy",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Jack",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "518129HD",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "E.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "The Home Depot - NW Fwy",
    shipToLine2: "14085 Northwest Fwy",
    shipToLine3: "Houston TX 77040",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 653261,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "10251 Kempwood Dr",
    customerCSZ: "Houston TX 77043",
    customerName: "H-E-B - Kempwood",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "George",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "29592 AR",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "Werner",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "H-E-B",
    shipToLine2: "10251 Kempwood Dr",
    shipToLine3: "Houston TX 77043",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 635151,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "14085 Northwest Fwy",
    customerCSZ: "Houston TX 77040",
    customerName: "The Home Depot - NW Fwy",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Jack",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "559921HD",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "E.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "14085 Northwest Fwy",
    shipToLine2: null,
    shipToLine3: null,
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 7325125,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "4412 North Fwy",
    customerCSZ: "Houston TX 77022",
    customerName: "Walmart - Independence Heights",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Wally",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "W95002",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "M.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Walmart - Independence Heights",
    shipToLine2: "4412 North Fwy",
    shipToLine3: "Houston, TX 77022",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 67426316311,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "9520 Cullen Blvd",
    customerCSZ: "Houston TX 77051",
    customerName: "Cadillac Express Car Wash",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Jack",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "6791219CE",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "E.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "9520 Cullen Blvd",
    shipToLine2: null,
    shipToLine3: null,
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 631631,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "14085 Northwest Fwy",
    customerCSZ: "Houston TX 77040",
    customerName: "The Home Depot - NW Fwy",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Jack",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "5029921HD",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "E.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "14085 Northwest Fwy",
    shipToLine2: null,
    shipToLine3: null,
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 935181063,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "2001 Gessner Rd",
    customerCSZ: "Houston TX 77080",
    customerName: "Joseph Tire Shop",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Jack",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "52915211TS",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "E.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "2001 Gessner Rd",
    shipToLine2: null,
    shipToLine3: null,
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 631616214342912,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "1231 Hahlo St",
    customerCSZ: "Houston TX 77020",
    customerName: "Pro Roadside and Towing",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Jack",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "56316151RS",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "E.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "1231 Hahlo St",
    shipToLine2: null,
    shipToLine3: null,
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 6316216216,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "3717 Main St",
    customerCSZ: "Houston TX 77004",
    customerName: "Sackett Auto Repair",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Jack",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "0618251SA",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "E.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "3717 Main St",
    shipToLine2: null,
    shipToLine3: null,
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 731617694872,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "10633 W Little York Rd",
    customerCSZ: "Houston TX 77041",
    customerName: "General Insulation",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Jack",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "93157152GE",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "E.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "10633 W Little York Rd",
    shipToLine2: null,
    shipToLine3: null,
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 723623,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "14085 Northwest Fwy",
    customerCSZ: "Houston TX 77040",
    customerName: "The Home Depot - NW Fwy",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Jack",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "581851HD",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "E.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "14085 Northwest Fwy",
    shipToLine2: null,
    shipToLine3: null,
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 631621216,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "16311 FM 529",
    customerCSZ: "Houston TX 77084",
    customerName: "Burlington",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Bob",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "CO251952",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "T.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Burlington",
    shipToLine2: "16311 FM 529",
    shipToLine3: "Houston, TX 77084",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 7263213,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "11902 Spring Cypress Rd",
    customerCSZ: "Houston TX 77039",
    customerName: "AutoZone - Cypress",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "John",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "AZ512952",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "S.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "AutoZone - Cypress",
    shipToLine2: "11902 Spring Cypress Rd",
    shipToLine3: "Houston TX 77039",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 6311631,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "14085 Northwest Fwy",
    customerCSZ: "Houston TX 77040",
    customerName: "The Home Depot - NW Fwy",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Jack",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "5204219HD",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "E.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "14085 Northwest Fwy",
    shipToLine2: null,
    shipToLine3: null,
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 63169511,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "16311 FM 529",
    customerCSZ: "Houston TX 77084",
    customerName: "Burlington",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Bob",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "CO93912",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "T.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Burlington",
    shipToLine2: "16311 FM 529",
    shipToLine3: "Houston, TX 77084",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 93521631,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "11902 Spring Cypress Rd",
    customerCSZ: "Houston TX 77039",
    customerName: "AutoZone - Cypress",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "John",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "AZ38195",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "S.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "AutoZone - Cypress",
    shipToLine2: "11902 Spring Cypress Rd",
    shipToLine3: "Houston TX 77039",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 9215216121,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "12717 Network Dr",
    customerCSZ: "Stafford TX 77477",
    customerName: "Costco - Stafford",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Cost",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "51612 CC",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "Co",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Costco - Stafford",
    shipToLine2: "12717 Network Dr",
    shipToLine3: "Stafford TX 77477",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 931921512521,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "16400 El Camino Real",
    customerCSZ: "Houston TX 77062",
    customerName: "Kroger - Clear Lake",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Bill",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "KRO92194",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "Kreuger",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Kroger - Clear Lake",
    shipToLine2: "16400 El Camino Real",
    shipToLine3: "Houston TX 77062",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 25161335,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "5655 East Sam Houston Pkwy N",
    customerCSZ: "Houston, TX 77015",
    customerName: "Walmart - Cloverleaf",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Bill",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "W521612",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "Kreuger",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Walmart - Cloverleaf",
    shipToLine2: "5655 East Sam Houston Pkwy N",
    shipToLine3: "Houston, TX 77015",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 92159620,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "11902 Spring Cypress Rd",
    customerCSZ: "Houston TX 77039",
    customerName: "AutoZone - Cypress",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "John",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "AZ99214",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "S.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "AutoZone - Cypress",
    shipToLine2: "11902 Spring Cypress Rd",
    shipToLine3: "Houston TX 77039",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 6316125,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "9235 N Sam Houston Pkwy E",
    customerCSZ: "Humble TX 77396",
    customerName: "Walmart - Beltway 8 N",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Wallace",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "W53951",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "M.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Walmart - Beltway 8 N",
    shipToLine2: "9235 N Sam Houston Pkwy E",
    shipToLine3: "Humble TX 77396",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 593003,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "2001 Clinton Dr",
    customerCSZ: "Galena Park TX 77547",
    customerName: "Family Dollar - Galena",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Smith",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "59390 FD",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "D.",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Family Dollar - Galena",
    shipToLine2: "2001 Clinton Dr",
    shipToLine3: "Galena Park TX 77547",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 921521,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "12717 Network Dr",
    customerCSZ: "Stafford TX 77477",
    customerName: "Costco - Stafford",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Cost",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "30610 CC",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "Co",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Costco - Stafford",
    shipToLine2: "12717 Network Dr",
    shipToLine3: "Stafford TX 77477",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 931921,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "16400 El Camino Real",
    customerCSZ: "Houston TX 77062",
    customerName: "Kroger - Clear Lake",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Bill",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "KRO39519",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "Kreuger",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Kroger - Clear Lake",
    shipToLine2: "16400 El Camino Real",
    shipToLine3: "Houston TX 77062",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
  {
    id: 251613,
    accountingAccount: "AR-32",
    billOfLading: null,
    closedDate: "2025-06-13T00:00:00",
    comments: null,
    custNo: "638262",
    customerAddress: "5655 East Sam Houston Pkwy N",
    customerCSZ: "Houston, TX 77015",
    customerName: "Walmart - Cloverleaf",
    customerName2: null,
    errorLevel: null,
    errorMessage: null,
    firstName: "Bill",
    homePhone: "555555555",
    hostItemId: "593226*3529",
    invoiceNumber: "W00292",
    invoiceType: "DEL",
    invSaleType: "ZE",
    isCompName: "OK",
    lastName: "Kreuger",
    middleName: null,
    numberOfParts: 7,
    openDate: "2025-05-20T00:00:00",
    poNumber: null,
    postedDate: null,
    postedTime: null,
    printedTime: null,
    quoteID: null,
    referNo: "52915",
    shipDate: "2025-06-13T00:00:00",
    shipToLine1: "Walmart - Cloverleaf",
    shipToLine2: "5655 East Sam Houston Pkwy N",
    shipToLine3: "Houston, TX 77015",
    shipToLine4: null,
    shipVia: "DILIGENT",
    totalAirFreightChg: 0.0,
    totalFees: null,
    totalFreightChg: 0.0,
    totalPartsCost: 51.21,
    totalPartsSale: 77.51,
    totalTax: 15.3,
    vehID: "ZEOFA39",
    voidDate: null,
    isImported: false,
    isHidden: false,
    dateTimeAdded: todayString,
    positionId: 0,
    cdkPositionLinkId: 0,
    sequence: 0,
    pod: null,
    attachments: null,
    signature: null,
    completedTime: null,
    positionDateTimeAdded: "0001-01-01T00:00:00",
  },
];

const dummyDrivers = [
  {
    position: "Daily Part Run",
    frequency: "YYYYNNN",
    name: "Jorge Gonzales",
    driverID: 55125,
    stops: [],
  },
  {
    position: "Transmission Loop",
    frequency: "YNYYYNN",
    name: "Spiderman",
    driverID: 51251,
    stops: [],
  },
  {
    position: "Westside run",
    frequency: "YYYNYNN",
    name: "Jimbo",
    driverID: 63131,
    stops: [],
  },
  {
    position: "Eastside run",
    frequency: "YYNYYNN",
    name: "My name is Naruto Uzumaki, and one day I'm going to be...",
    driverID: 76235,
    stops: [],
  },
  {
    position: "Downtown Drop Off",
    frequency: "YYYYYNN",
    name: "Jake From State Farm",
    driverID: 99650,
    stops: [],
  },
  {
    position: "Weekend",
    frequency: "NNNNNYY",
    name: "The Jeff",
    driverID: 65002,
    stops: [],
  },
  {
    position: "Parts Sprint",
    frequency: "YYYYYNN",
    name: 'Casey "Casette" Case',
    driverID: 65219,
    stops: [],
  },
];

// Component Start
export const DedicatedDispatchBoard = ({ loading, setLoading }) => {
  const [orderTerminology, setOrderTerminology] = useLocalStorage({
    key: localStorageVariables.orderTerminology,
    initialValue: orderAndPositionTerminologyOptions.orderTerminology.order,
    options: { deserializer: (value) => value },
  });
  const orderTermLowerCase = orderTerminology?.toLowerCase();
  const [positionTerminology, setPositionTerminology] = useLocalStorage({
    key: localStorageVariables.positionTerminology,
    initialValue:
      orderAndPositionTerminologyOptions.positionTerminology.position,
    options: { deserializer: (value) => value },
  });
  const positionTermLowerCase = positionTerminology?.toLowerCase();
  // console.log("terminology", orderTerminology);
  // console.log("terminology", positionTerminology);

  const [decodedToken, setDecodedToken] = useDecodeToken();
  const isDemoAccountBool = useMemo(
    () => isDemoAccountFunc(decodedToken),
    [decodedToken],
  );
  const [readOnly, setReadOnly] = useState(
    isReadOnly(decodedToken) &&
      decodedToken?.nameid?.toLowerCase() !== "csrdemo",
  );
  const [showAllPositions, setShowAllPositions] = useState(false);
  const [orders, setOrders] = useState([]);
  const [positions, setPositions] = useState([]);
  const [manualOrderCount, setManualOrderCount] = useState(0);
  // const [positions, setPositions] = useState(() => {
  //   return cloneDeep(dummyDrivers);
  // });
  const [currentViewStates, setCurrentViewStates] = useState({
    overall: viewStates.loading, // if this is loading, display gleam panels for every panel
    orders: viewStates.loading,
    positions: viewStates.loading,
    stops: viewStates.loading,
  });
  const mapRef = useRef();
  const [mapApiKey, setMapApiKey] = useState();
  const [clientLocation, setClientLocation] = useState();
  const [clientCoordinates, setClientCoordinates] = useState();
  //On Page Load
  useEffect(() => {
    const fetchData = async () => {
      // console.log("this ran");
      try {
        setLoading(true);
        setCurrentViewStates((prev) => {
          return {
            ...prev,
            overall: viewStates.loading,
            orders: viewStates.loading,
            positions: viewStates.loading,
            stops: viewStates.loading,
          };
        });
        await handleLoadPositionsAndOrdersForDedicatedDispatchBoard(
          daysToLookAt,
        );
        const locationResponse = await getClientLocation();
        const mapApiKeyResponse = await getMapApiKey();
        setMapApiKey(mapApiKeyResponse.data);
        const clientLocation = {
          name: locationResponse.data.mastername,
          address: locationResponse.data.address,
          city: locationResponse.data.city,
          state: locationResponse.data.state,
          zip: locationResponse.data.zip,
          suite: locationResponse.data.suite,
        };
        const clientLocationString = generateLocationString(clientLocation);
        //TODO check if this already exists in local storage and only do this if it does.
        const clientLocInfo = JSON.parse(
          localStorage.getItem(localStorageVariables.clientLoc),
        );
        // console.log("clientLocInfo", clientLocInfo);
        //check if we previously stored the geocoordinates in local storage and the location hasn't changed (it probably never would but still. e.g. address correction)
        if (
          clientLocInfo &&
          clientLocInfo.text === clientLocationString &&
          clientLocInfo.coords
        ) {
          // console.log("get from local");
          setClientCoordinates(clientLocInfo.coords);
          setClientLocation(clientLocation);
        } else {
          // console.log("get from google");
          // const geocodedLocationResponse = await mapsApiAxios.get(
          //   "https://maps.googleapis.com/maps/api/geocode/json",
          //   {
          //     params: {
          //       address: clientLocationString,
          //       key: apizk,
          //     },
          //   }
          // );
          const geocodedLocationResponse =
            await getGeoCoordinatesForAddress(clientLocationString);

          setClientLocation(clientLocation);
          setClientCoordinates(
            geocodedLocationResponse.data?.results[0].geometry.location,
          );
          localStorage.setItem(
            localStorageVariables.clientLoc,
            JSON.stringify({
              text: clientLocationString,
              coords:
                geocodedLocationResponse.data?.results[0].geometry.location,
            }),
          );
          // console.log("geocoded client location", geocodedLocationResponse);
        }

        // const hi = await new Promise((r) => setTimeout(r, 2000)); for testing loading state
        // console.log("positions response", response);
        setCurrentViewStates((prev) => {
          return {
            ...prev,
            overall: viewStates.success,
            orders: viewStates.success,
            positions: viewStates.success,
            stops: viewStates.success,
          };
        });
      } catch (ex) {
        handleApiError(ex);
        toast.error(ex);
        setCurrentViewStates((prev) => {
          return {
            ...prev,
            overall: viewStates.error,
            orders: viewStates.error,
            positions: viewStates.error,
            stops: viewStates.error,
          };
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // console.log("Current positions", positions);
  // console.log("current orders", orders);

  // const handleClickSimulateRoute = async () => {
  //   if (
  //     !selectedPosition ||
  //     selectedPosition.stops.filter(
  //       (stop) => stop.status === dedicatedOrderStatuses.submitted
  //     ).length === 0
  //   ) {
  //     return;
  //   }
  //   let i = 0;
  //   for await (const stopToComplete of selectedPosition.stops) {
  //     setPositions((prev) => {
  //       return prev.map((position) => {
  //         if (position.positionID === selectedPositionID) {
  //           return {
  //             ...position,
  //             stops: position.stops.map((stop) => {
  //               if (stop.deliveryId === stopToComplete.deliveryId) {
  //                 return {
  //                   ...stop,
  //                   status:
  //                     stop.status === dedicatedOrderStatuses.submitted
  //                       ? dedicatedOrderStatuses.completed
  //                       : stop.status,
  //                 };
  //               } else {
  //                 return stop;
  //               }
  //             }),
  //           };
  //         } else {
  //           return position;
  //         }
  //       });
  //     });
  //     setPositionMapCache((prev) => {
  //       const prevRoute = prev[selectedPositionID].route;
  //       const prevLegs = prevRoute.legs;
  //       const legsWithUpdate = prevLegs.map((leg, index) => {
  //         if (index === i) {
  //           return { ...leg, status: dedicatedOrderStatuses.completed };
  //         } else {
  //           return leg;
  //         }
  //       });
  //       const routeWithUpdate = { ...prevRoute, legs: legsWithUpdate };
  //       return {
  //         ...prev,
  //         [selectedPositionID]: {
  //           ...prev[selectedPositionID],
  //           route: routeWithUpdate,
  //         },
  //       };
  //     });
  //     i++;
  //     await sleep(2000);
  //   }
  // };

  const handleSubmitOrdersForPosition = async (e, positionID) => {
    try {
      setLoading(true);
      //if position id is passed, update that position,
      //if not, just use the currently selected position
      const positionIDToSubmit = positionID ?? selectedPositionID;
      const positionToSubmit = positionID
        ? positions.find((position) => {
            return position.positionID === positionID;
          })
        : selectedPosition;
      // console.log("position to submit", positionToSubmit);
      //Expected Type to send
      //  const orderAssignments: {
      //     cxtDedicatedAddress: {
      //       streetName: string;
      //       cityName: string;
      //       state: string;
      //       zipCode: string;
      //       customerName: string;
      //     }
      //     cxtDedicatedPosition: {
      //       positionName: string;
      //       driverName: string;
      //       positionId: number;
      //     }
      //     parcelInformation: {
      //       orderId: number;
      //       invoiceNumber: string;
      //       totalPartCost: number;
      //       totalPartSale: number;
      //       partsCount: number;
      //       sequenceNumber: number;
      //     }
      //     stopType: number;
      //   }
      // console.log("SELECTED POSITION", selectedPosition);

      //generate sequence numbers based on current order
      //this may differ from the sequence field that is retrieved for already submitted orders on page load.
      const stopsWithSequenceNumbers = positionToSubmit.stops.map(
        (stop, index) => {
          return { ...stop, sequenceNumber: index + 1 };
        },
      );

      //ORDERS TO MODIFY
      const ordersToModifyIdMap = {};
      const ordersToModify = stopsWithSequenceNumbers
        .filter((stop) => {
          return (
            stop.status !== dedicatedOrderStatuses.unSubmitted &&
            (stop.sequence !== stop.sequenceNumber ||
              //if the switch driver cache has this order in it, we know we need to modify this
              switchDriverCache[positionIDToSubmit]?.orders?.find(
                (switchedOrder) => {
                  return switchedOrder.deliveryId === stop.deliveryId;
                },
              ))
          );
        })
        .map((stop, index) => {
          ordersToModifyIdMap[stop.deliveryId] = true;
          return {
            address: {
              streetName: stop.address,
              cityName: stop.city,
              state: stop.state,
              zipCode: stop.zip,
              customerName: stop.customerName,
            },
            position: {
              positionName: positionToSubmit.positionName,
              driverName: positionToSubmit.driverName,
              positionId: positionToSubmit.positionID,
              // positionId: 40540,
            },
            parcelInformation: {
              orderId: stop.deliveryId,
              invoiceNumber: stop.invoiceNumber,
              totalPartCost: stop.originalData.totalPartsCost, //note that the backend accepts totalPartCost but the field is called totalPartsCost with Parts plural
              totalPartSale: stop.isManual
                ? stop.totalValue
                : stop.originalData.totalPartsSale, //note that the backend accepts totalPartSale but the field is called totalPartsSale with Parts plural
              partsCount: stop.originalData.numberOfParts,
              sequenceNumber: stop.sequenceNumber,
              notes: stop.isManual ? stop.notes : stop.originalData.comments,
              cdkPositionLinkId: stop.cdkPositionLinkId,
            },
            stopType: stop.stopType,
          };
        });

      // console.log("orders to modify map", ordersToModifyIdMap);

      //ORDERS TO SUBMIT/CREATE/INSERT
      const ordersToSubmitIdMap = {};
      const ordersToSubmit = stopsWithSequenceNumbers
        .filter((stop) => {
          // console.log("testing submission - stop", stop);
          return stop.status === dedicatedOrderStatuses.unSubmitted;
        })
        .map((stop, index) => {
          ordersToSubmitIdMap[stop.deliveryId] = true;
          return {
            address: {
              streetName: stop.address,
              cityName: stop.city,
              state: stop.state,
              zipCode: stop.zip,
              customerName: stop.customerName,
            },
            position: {
              positionName: positionToSubmit.positionName,
              driverName: positionToSubmit.driverName,
              positionId: positionToSubmit.positionID,
              // positionId: 40540,
            },
            parcelInformation: {
              orderId: stop.deliveryId,
              invoiceNumber: stop.invoiceNumber,
              totalPartCost: stop.originalData.totalPartsCost, //note that the backend accepts totalPartCost but the field is called totalPartsCost with Parts plural
              totalPartSale: stop.isManual
                ? stop.totalValue
                : stop.originalData.totalPartsSale, //note that the backend accepts totalPartSale but the field is called totalPartsSale with Parts plural
              partsCount: stop.originalData.numberOfParts,
              sequenceNumber: stop.sequenceNumber,
              notes: stop.isManual ? stop.notes : stop.originalData.comments,
            },
            stopType: stop.stopType,
          };
        });

      if (ordersToSubmit.length === 0 && ordersToModify.length === 0) {
        toast.error(
          "No changes to submit." +
            (positionID ? ` (Original ${positionTerminology})` : ""),
        );
        return;
      }

      if (ordersToModify.length > 0) {
        if (!isDemoAccountBool) {
          const modificationResponse =
            await modifyOrdersForPosition(ordersToModify);
        }
        setSwitchDriverCache((prev) => {
          return { ...prev, [positionIDToSubmit]: { orders: [], from: null } }; //empty out the switched orders cache for this driver after successful modification
        });
        toast.success(
          `Modified ${ordersToModify.length} orders.${
            positionID ? ` (Original ${positionTerminology})` : ""
          }`,
        );
      }
      if (ordersToSubmit.length > 0) {
        if (!isDemoAccountBool) {
          const submissionResponse =
            await submitOrdersForPosition(ordersToSubmit);
        }
        toast.success(
          `Submitted ${ordersToSubmit.length} orders.${
            positionID ? ` (Original ${positionTerminology})` : ""
          }`,
        );
      }

      const { cdkPositionLinkIdsBySequence, cdkPositionLinkIdsById } =
        await getCdkPositionLinkIdsBySequenceNumberForPositionOnSubmission(
          positionIDToSubmit,
        );
      setOrders((prev) => {
        return prev.map((order) => {
          return {
            ...order,
            status: ordersToSubmitIdMap[order.deliveryId]
              ? dedicatedOrderStatuses.submitted
              : order.status,
            cdkPositionLinkId: ordersToSubmitIdMap[order.deliveryId]
              ? cdkPositionLinkIdsById[order.deliveryId]
              : order.cdkPositionLinkId,
          };
        });
      });
      setPositions((prev) => {
        return prev.map((position) => {
          if (position.positionID === positionIDToSubmit) {
            return {
              ...position,
              wasSubmitted: true,
              stops: position.stops.map((prevStop, index) => {
                // console.log(
                //   "link id for stop",
                //   cdkPositionLinkIdsById[prevStop.deliveryId]
                // );
                return {
                  ...prevStop,
                  status: ordersToSubmitIdMap[prevStop.deliveryId]
                    ? dedicatedOrderStatuses.submitted
                    : prevStop.status,
                  sequence: index + 1, //on a successful add or modify, the sequence number will be the same as index+1 anyway
                  cdkPositionLinkId:
                    cdkPositionLinkIdsById[prevStop.deliveryId],
                };
              }),
            };
          } else {
            return position;
          }
        });
      });
      if (switchDriverCache[positionIDToSubmit]?.orders?.length > 0) {
        handleSubmitOrdersForPosition(
          null,
          switchDriverCache[positionIDToSubmit]?.from,
        );
      }
      // console.log("ORDERS TO SEND", ordersToSubmit);
      // console.log("submission repsonse", hi);
    } catch (ex) {
      handleApiError(ex);
    } finally {
      setLoading(false);
    }
  };
  // console.log("complete positions", positions);
  const [daysToLookAt, setDaysToLookAt] = useState(3); //Hard coding the backend call to be 3 days. The front end will do the actual filtering. This is to prevent an order from 3 days ago being assigned, but then they refresh and we only pull 1 days worth of orders, causing the assigned order to not show.
  // const [frontEndDaysToLookAt, setFrontEndDaysToLookAt] = useState(1);
  // const handleChangeFrontEndDaysToLookAt = (e) => {
  //   setFrontEndDaysToLookAt(e.target.value);
  // };

  const processOrders = useCallback((cdkOrders = [], manualOrders = []) => {
    // console.log("orders", ordersToProcess);
    // Only display CDKRawDataFieldsToHide for master clients
    // Maybe make settings for them to set which are hidden?
    // CDKRawDataFieldsToHide
    // const testOrders = cloneDeep(orders);
    // base address, city, state, zip, etc over the fields that work best for now (customerAddress, customerCSZ vs shipToLine1, shipToLine2, shipToLine3, shipToLine4, etc)
    // But later we want to let the user be able to pick the default fields to base it off of.
    let orderAssignmentsDict = {};
    const processedCdkOrders = cdkOrders
      .filter((order) => {
        //for regular cdk orders we want to display all unassigned orders for the requested time frame, in case they want to assign orders that were placed and not sent out on a previous day,
        //as well as the assigned orders for today only (don't want to show orders that were assigned on a previous day).
        return (
          //This is ANY unsubmitted order OR ANY order regardless of status for that was submitted today.
          determineDedicatedOrderStatus(order) ===
            dedicatedOrderStatuses.unSubmitted ||
          order.positionDateTimeAdded?.split("T")?.[0] >= todayString
        );
      })
      .map((order) => {
        const processedDestination = generateCDKDestinationInfo(order);
        const processedOrderObject = {
          originalData: order,
          deliveryId: "" + order.id, // converting this to a string because sometimes we prepend/append text to mark it as an overlay or manual order. Might change that later to mark as overlay/manual through the draggable event state passed in useSortable.
          invoiceNumber: order.invoiceNumber,
          customerName: processedDestination.customerName,
          customerName2: processedDestination.customerName2,
          address: processedDestination.address,
          city: processedDestination.city,
          state: processedDestination.state,
          zip: processedDestination.zip,
          assignedTo: order.positionId,
          stopType: CXTStopTypes.delivery.value, //set stop types to delivery by default for now.
          sequence: order.sequence, //the sequence retrieved from the database, DIFFERENT from the on page sequence that is generated before submission which is based on the current position in the array instead.
          hidden: order.positionId ? true : false,
          status: determineDedicatedOrderStatus(order),
          cdkPositionLinkId: order.cdkPositionLinkId,
          dateTimeAdded: order.dateTimeAdded,
          locationString: generateLocationString(processedDestination),
          locationStringWithoutName: generateLocationString(
            processedDestination,
            false,
          ),
          locationKey: generateLocationKey(processedDestination),
        };
        if (order.positionId) {
          // console.log("order has position id", order.positionId);
          if (orderAssignmentsDict[order.positionId]) {
            orderAssignmentsDict[order.positionId].push(processedOrderObject);
          } else {
            orderAssignmentsDict[order.positionId] = [processedOrderObject];
          }
        }
        return processedOrderObject;
      });
    const processedManualOrders = manualOrders
      .filter((manualOrder) => {
        //filter out manual orders from previous days if we get them because
        //on the unsubmitted orders panel we DO want orders from a few days back displayed if requested
        //But manual orders are not displayed there so we can just filter them out entirely
        // console.log("date compare", manualOrder.dateTimeAdded?.split("T")?.[0]);
        // console.log("date compare", todayString);
        // console.log(
        // "date compare",
        // manualOrder.dateTimeAdded?.split("T")?.[0] >= todayString
        // );
        return manualOrder.dateTimeAdded.split("T")?.[0] >= todayString;
      })
      .map((order, index) => {
        const processedManualOrderObject = {
          ...order,
          zip: order.zipCode,
          invoiceNumber: "Manual",
          deliveryId: "Manual" + (index + 1),
          assignedTo: order.positionId,
          status: determineDedicatedOrderStatus(order),
          isManual: true,
          originalData: {
            totalPartsCost: 0,
            totalPartsSale: 0,
            numberOfParts: 1,
          },
        };
        if (order.positionId) {
          if (orderAssignmentsDict[order.positionId]) {
            orderAssignmentsDict[order.positionId].push(
              processedManualOrderObject,
            );
          } else {
            orderAssignmentsDict[order.positionId] = [
              processedManualOrderObject,
            ];
          }
        }
        return processedManualOrderObject;
      });
    const allOrders = [...processedCdkOrders, ...processedManualOrders];
    // console.log("processed orders", processedCdkOrders);
    return {
      processedOrders: allOrders,
      assignments: orderAssignmentsDict,
      numManualOrders: processedManualOrders.length,
    };
  }, []);

  //the date you are looking at and how many days worth of orders from before that date you want to load
  const handleLoadPositionsAndOrdersForDedicatedDispatchBoard = useCallback(
    async (lastXDays) => {
      try {
        const ordersResponse = await getCdkOrders(true, lastXDays);
        // console.log("orders onpageload", ordersResponse);
        const { cdkOrders, manualOrders } = ordersResponse.data; //{cdkOrders:[], manualOrders:[]}
        // const allOrders = [
        //   ...orders.cdkOrders,
        //   ...orders.manualOrders
        // ];
        const positionsResponse = isDemoAccountBool
          ? { data: [...dummyPositions] }
          : await getPositions();
        const positionsTemp = positionsResponse.data?.map((position) => {
          return {
            positionName: position.posname,
            positionID: position.ctposid,
            driverID: position.drvid,
            driverName: position.fullname,
            frequency: position.freq,
            stops: [],
            wasSubmitted: false,
          };
        });

        //We only care about manual orders that were assigned today (ignore previous days manual orders as we wouldn't want to show them in today's assignments or unassigned orders either)
        //that's why we're passing in manual orders. They will be returned in the assignments array, as well as how many are relevant for today in numManualOrders
        const { processedOrders, assignments, numManualOrders } = processOrders(
          decodedToken?.nameid?.toLowerCase() === "csrdemo"
            ? [...dummyOrders]
            : cdkOrders,
          manualOrders,
        );
        setManualOrderCount(numManualOrders);
        setOrders(processedOrders);
        // console.log("assignments: ", assignments);
        setPositions(
          positionsTemp.map((position) => {
            if (assignments[position.positionID]) {
              return {
                ...position,
                wasSubmitted: true,
                // dirty: assignments[position.positionID]?.length > 0,//NVM this is handled in the positionMapCache //mark the position dirty if it had previously assigned stops on page load, so that the route is loaded when switching ot them.
                stops: assignments[position.positionID].sort(
                  //sort by sequence number
                  (a, b) => a.sequence - b.sequence,
                ),
              };
            } else {
              return position;
            }
          }),
        );
        // console.log("assignments", assignments);
        const dirtyPositionIds = Object.entries(assignments).filter(
          (assignment) => {
            // console.log("assignment value", assignment);
            return assignment[1]?.length > 0;
          },
        );
        // console.log("position map cache", positionMapCache);
        setPositionMapCache((prev) => {
          const previousPositionMapCache = { ...prev };
          for (let i = 0; i < dirtyPositionIds.length; i++) {
            //Potentially could mark positions that are no longer active as true in here, but since they are not active and can't be clicked on, might not matter?
            previousPositionMapCache[dirtyPositionIds[i][0]] = {
              ...previousPositionMapCache[dirtyPositionIds[i][0]],
              dirty: true,
            };
          }
          return previousPositionMapCache;
        });
      } catch (ex) {
        toast.error("" + ex);
      }
    },

    [positions, setPositions],
  );

  //Old way: needed positions to already be loaded before running.
  //   //the date you are looking at and how many days worth of orders from before that date you want to load
  // const handleSearchForCDKDedicatedOrders = useCallback(
  //   async (lastXDays) => {
  //     try {
  //       const ordersResponse = await getCdkOrders(true, lastXDays);
  //       // console.log("orders onpageload", ordersResponse);
  //       const { cdkOrders, manualOrders } = ordersResponse.data; //{cdkOrders:[], manualOrders:[]}
  //       // const allOrders = [
  //       //   ...orders.cdkOrders,
  //       //   ...orders.manualOrders
  //       // ];
  //       const { processedOrders, assignments, numManualOrders } = processOrders(
  //         cdkOrders,
  //         manualOrders
  //       );
  //       setManualOrderCount(numManualOrders);
  //       setOrders(processedOrders);
  //       // console.log("assignments: ", assignments);
  //       setPositions((prev) => {
  //         //Potentially could assign stops to positions that are no longer active in here but might not matter since they are not viewable anyway?
  //         return prev.map((position) => {
  //           if (assignments[position.positionID]) {
  //             return {
  //               ...position,
  //               wasSubmitted: true,
  //               // dirty: assignments[position.positionID]?.length > 0,//NVM this is handled in the positionMapCache //mark the position dirty if it had previously assigned stops on page load, so that the route is loaded when switching ot them.
  //               stops: assignments[position.positionID].sort(
  //                 //sort by sequence number
  //                 (a, b) => a.sequence - b.sequence
  //               ),
  //             };
  //           } else {
  //             return position;
  //           }
  //         });
  //       });
  //       // console.log("assignments", assignments);
  //       const dirtyPositionIds = Object.entries(assignments).filter(
  //         (assignment) => {
  //           // console.log("assignment value", assignment);
  //           return assignment[1]?.length > 0;
  //         }
  //       );
  //       // console.log("position map cache", positionMapCache);
  //       setPositionMapCache((prev) => {
  //         const previousPositionMapCache = { ...prev };
  //         for (let i = 0; i < dirtyPositionIds.length; i++) {
  //           //Potentially could mark positions that are no longer active as true in here, but since they are not active and can't be clicked on, might not matter?
  //           previousPositionMapCache[dirtyPositionIds[i][0]] = {
  //             ...previousPositionMapCache[dirtyPositionIds[i][0]],
  //             dirty: true,
  //           };
  //         }
  //         return previousPositionMapCache;
  //       });
  //     } catch (ex) {
  //       toast.error("" + ex);
  //     }
  //   },

  //   [positions, setPositions]
  // );

  const fetchNewOrdersAndStatusUpdates = useCallback(
    async (lastXDays) => {
      //Don't fetch new orders and status updates for the demo account
      if (decodedToken?.nameid?.toLowerCase() === "csrdemo") {
        return;
      }
      try {
        const ordersResponse = await getCdkOrders(true, daysToLookAt); //We could probably hard code this to 1 since it's supposed to be new orders and statuses anyway.
        const { cdkOrders, manualOrders } = ordersResponse.data; //{cdkOrders:[], manualOrders:[]}

        const { processedOrders, assignments, numManualOrders } = processOrders(
          cdkOrders,
          manualOrders,
        );

        //Make sure not to mess up data that the user has been working with, when doing these updates.

        //Fetch any new orders that have come in and add them to the unassigned orders section
        setOrders((prevOrders) => {
          const prevOrdersDictionary = {};
          for (let i = 0; i < prevOrders.length; i++) {
            prevOrdersDictionary[prevOrders[i].deliveryId] = true;
          }
          // console.log("order refresh - prev orders", prevOrdersDictionary);
          const ordersToAdd = processedOrders.filter((order) => {
            //only add orders that do not already exist.
            return !prevOrdersDictionary[order.deliveryId];
          });
          // console.log("order refresh - orders to add", ordersToAdd);
          return [...prevOrders, ...ordersToAdd]; //Should all the orders be sorted or just add the new orders to the bottom? Maybe to the top instead? Either way once we add proper sorting options, it shouldn't matter?
        });

        //Update assigned orders with their current status
        setPositions((prev) => {
          return prev.map((prevPosition) => {
            //if the current position had submitted assignments, go ahead and check for status updates and assign them if needed, else return it unchanged.
            if (assignments[prevPosition.positionID]) {
              const statusesByPositionLinkId = assignments[
                prevPosition.positionID
              ].reduce((rolling, currentOrder) => {
                return {
                  ...rolling,
                  [currentOrder.cdkPositionLinkId]: currentOrder.status,
                  // determineOrderStatus(currentOrder), //statuses are already generated in the proceessOrders function, so we just use the status field instead
                };
              }, {});
              // console.log(
              //   "statuses by position Link Id",
              //   statusesByPositionLinkId
              // );
              return {
                ...prevPosition,
                stops: prevPosition?.stops?.map((prevStop) => {
                  //loop through stops and update statuses as needed.
                  //all submitted orders should have a cdkPositionLinkId
                  //and we only update the status for orders that do
                  if (statusesByPositionLinkId[prevStop.cdkPositionLinkId]) {
                    return {
                      ...prevStop,
                      status:
                        statusesByPositionLinkId[prevStop.cdkPositionLinkId],
                    };
                  } else {
                    return prevStop;
                  }
                }),
              };
            } else {
              return prevPosition;
            }
          });
        });
        //update the route legs to be gray
      } catch (ex) {
        handleApiError(ex);
      }
    },
    [daysToLookAt],
  );

  //WE NEED TO GET cdkPostionLinkIds for orders after we post, mainly due to manual orders not having a unique id to link status updates back to until after they are posted
  //Initially planning to use positionID + sequence number to identify manual orders but their sequence can be modified thus that wouldn't work.
  const getCdkPositionLinkIdsBySequenceNumberForPositionOnSubmission =
    useCallback(
      async (positionID) => {
        const ordersResponse = await getCdkOrders(true, daysToLookAt);
        const { cdkOrders, manualOrders } = ordersResponse.data; //{cdkOrders:[], manualOrders:[]}

        const cdkPositionLinkIdsBySequence = {}; //to update stops after post
        const cdkPositionLinkIdsById = {}; //to update the orders state array after post
        for (let i = 0; i < cdkOrders.length; i++) {
          if (cdkOrders[i].positionId === positionID) {
            cdkPositionLinkIdsBySequence[cdkOrders[i].sequence] =
              cdkOrders[i].cdkPositionLinkId;
            cdkPositionLinkIdsById[cdkOrders[i].id] =
              cdkOrders[i].cdkPositionLinkId;
          }
        }
        for (let i = 0; i < manualOrders.length; i++) {
          if (manualOrders[i].positionId === positionID) {
            cdkPositionLinkIdsBySequence[manualOrders[i].sequence] =
              manualOrders[i].cdkPositionLinkId;
          }
        }
        //The cdkpositionlinkidsbysequence will mix up linkids for the same sequence on orders from previous days,
        //so if you do decided to use it, change the code to make sure only orders for TODAY are pulled.
        //Probably just remove it.
        return { cdkPositionLinkIdsBySequence, cdkPositionLinkIdsById };
      },
      [daysToLookAt],
    );

  useEffect(() => {
    const intervalID = setInterval(() => {
      //get status updates
      fetchNewOrdersAndStatusUpdates(daysToLookAt);
    }, 300000); //every 5 minutes
    return () => {
      clearInterval(intervalID);
    };
  }, [daysToLookAt]);

  const [selectedPositionID, setSelectedPositionID] = useState();
  const selectedPosition = useMemo(
    () =>
      positions.find((position) => position.positionID === selectedPositionID),
    [positions, selectedPositionID],
  );
  const handleSelectPositionID = (newSelectedPositionID) => {
    setSelectedPositionID((prev) =>
      prev === newSelectedPositionID ? null : newSelectedPositionID,
    );
    if (selectedPositionID !== newSelectedPositionID) {
      // console.log("selected position", newSelectedPositionID);
      // console.log("position map cache", positionMapCache);
      // console.log(
      //   "position is dirty",
      //   positionMapCache[newSelectedPositionID]?.dirty
      // );
      if (positionMapCache[newSelectedPositionID]?.dirty) {
        // console.log("Updated map because switched to dirty position");
        setMapUpdateNotifier((prev) => prev + 1);
      }
    }
  };

  //route leg statuses, indexToPhysicalStopNumber, latestCompletedOrderPhysicalStopNumber
  const physicalStopData = useMemo(() => {
    const indexToPhysicalStopNumberMap = generateIndexToPhysicalStopNumberMap(
      selectedPosition?.stops,
    );
    const statusesByOrderIndex = selectedPosition?.stops.map((stop) => {
      return stop.status;
    });
    // console.log("statuses by order index", statusesByOrderIndex);
    // console.log("indexToPhysicalStopNumberMap", indexToPhysicalStopNumberMap);
    const latestCompleteOrder = statusesByOrderIndex?.findLastIndex(
      (status) => status === dedicatedOrderStatuses.completed,
    );
    const latestCompletedOrderPhysicalStopNumber =
      indexToPhysicalStopNumberMap[latestCompleteOrder];
    const physicalStopStatuses = Object.entries(
      indexToPhysicalStopNumberMap,
    ).reduce((rolling, current, index) => {
      // console.log("current", current);
      // console.log("rolling", rolling);
      rolling[current[1] - 1] =
        rolling?.[current[1] - 1] === dedicatedOrderStatuses.completed
          ? dedicatedOrderStatuses.completed
          : statusesByOrderIndex[current[0]] !==
                dedicatedOrderStatuses.completed &&
              latestCompletedOrderPhysicalStopNumber - 1 > index
            ? dedicatedOrderStatuses.missed
            : statusesByOrderIndex[current[0]];
      return rolling;
    }, {});
    return {
      indexToPhysicalStopNumberMap: indexToPhysicalStopNumberMap,
      latestCompletedStopIndex: latestCompleteOrder,
      latestCompletedOrderPhysicalStopNumber:
        latestCompletedOrderPhysicalStopNumber,
      routeLegStatuses: physicalStopStatuses,
    };
  }, [positions, selectedPositionID]);
  // console.log(physicalStopData);

  const completeStopTestFunction = (positionIDToComplete, deliveryId) => {
    console.log(
      "positionid",
      positionIDToComplete,
      "cdkpositionlinkid",
      deliveryId,
    );
    let indexOfCompletedStop;
    const indexToPhysicalStopNumberMap = generateIndexToPhysicalStopNumberMap(
      positions.find((position) => {
        return position.positionID === positionIDToComplete;
      })?.stops,
    );
    console.log(
      "index to physical stop number map",
      indexToPhysicalStopNumberMap,
    );
    setPositions((prev) => {
      return prev.map((prevPosition) => {
        if (prevPosition.positionID === positionIDToComplete) {
          return {
            ...prevPosition,
            stops: prevPosition?.stops?.map((prevStop, index) => {
              //loop through stops and update statuses as needed.
              //all submitted orders should have a cdkPositionLinkId
              //and we only update the status for orders that do
              if (prevStop.deliveryId === deliveryId) {
                indexOfCompletedStop = index;
                console.log("completed stop through test function");
                return {
                  ...prevStop,
                  status: dedicatedOrderStatuses.completed,
                };
              } else {
                return prevStop;
              }
            }),
          };
        } else {
          return prevPosition;
        }
      });
    });
    // setPositionMapCache((prevPositionMapCache) => {
    //   console.log(
    //     "old map for position",
    //     prevPositionMapCache[positionIDToComplete]
    //   );
    //   const prevRoute = {
    //     ...prevPositionMapCache[positionIDToComplete]?.route,
    //   };
    //   return {
    //     ...prevPositionMapCache,
    //     [positionIDToComplete]: {
    //       ...prevPositionMapCache[positionIDToComplete],
    //       route: {
    //         ...prevPositionMapCache[positionIDToComplete]?.route,
    //         legs: prevPositionMapCache[positionIDToComplete]?.route?.legs?.map(
    //           (leg, index) => {
    //             if (
    //               index <=
    //               indexToPhysicalStopNumberMap[indexOfCompletedStop] - 1
    //             ) {
    //               return { ...leg, status: dedicatedOrderStatuses.completed };
    //             } else {
    //               return leg;
    //             }
    //           }
    //         ),
    //       },
    //     },
    //   };
    // });
  };
  const completeNextOrderTestFunction = () => {
    if (!selectedPositionID) {
      return;
    }
    if (selectedPosition.stops.length === 0) {
      return;
    }
    const positionIDToComplete = selectedPositionID;

    const orderIndexToComplete = selectedPosition.stops.findIndex((order) => {
      return order.status != dedicatedOrderStatuses.completed;
    });
    console.log("completing order #", orderIndexToComplete + 1);
    //if we wanted to do it by physical stop number instead of order, but currently doing it by order
    // const indexToPhysicalStopNumberMap = generateIndexToPhysicalStopNumberMap(
    //   selectedPosition.stops
    // );
    // console.log(
    //   "index to physical stop number map",
    //   indexToPhysicalStopNumberMap
    // );
    setPositions((prev) => {
      return prev.map((prevPosition) => {
        if (prevPosition.positionID === positionIDToComplete) {
          return {
            ...prevPosition,
            stops: prevPosition?.stops?.map((prevStop, index) => {
              if (index === orderIndexToComplete) {
                return {
                  ...prevStop,
                  status: dedicatedOrderStatuses.completed,
                };
              } else {
                return prevStop;
              }
            }),
          };
        } else {
          return prevPosition;
        }
      });
    });
    // setPositionMapCache((prevPositionMapCache) => {
    //   console.log(
    //     "old map for position",
    //     prevPositionMapCache[positionIDToComplete]
    //   );
    //   const prevRoute = {
    //     ...prevPositionMapCache[positionIDToComplete]?.route,
    //   };
    //   return {
    //     ...prevPositionMapCache,
    //     [positionIDToComplete]: {
    //       ...prevPositionMapCache[positionIDToComplete],
    //       route: {
    //         ...prevPositionMapCache[positionIDToComplete]?.route,
    //         legs: prevPositionMapCache[positionIDToComplete]?.route?.legs?.map(
    //           (leg, index) => {
    //             if (
    //               index <=
    //               indexToPhysicalStopNumberMap[indexOfCompletedStop] - 1
    //             ) {
    //               return { ...leg, status: dedicatedOrderStatuses.completed };
    //             } else {
    //               return leg;
    //             }
    //           }
    //         ),
    //       },
    //     },
    //   };
    // });
  };

  // DND setup
  // const { isOverStops, setNodeRef } = useDroppable({
  //   id: "stopDropzone",
  // });
  // const {
  //   active,
  //   attributes,
  //   isDragging,
  //   listeners,
  //   over,
  //   setNodeRef,
  //   transition,
  //   transform,
  // } = useSortable({
  //   id: "stopsDropzone",
  //   data: {
  //     type: "container",
  //   },
  // });
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 15,
        // delay: 3000,
        // tolerance: 0,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
    //this enabled pickup of drag items using touch but they would almost immediately cancel
    //removing this and adding touch-action
    // useSensor(TouchSensor, {
    //   activationConstraint: {
    //     distance: 15,
    //   },
    // })
  );

  const determinePositionHasDeparted = useCallback(
    (position) => {
      //If a positionID is passed, check that, if not just check the currently selected position.
      // const positionToCheck = positionID ? positions.find(position=>position.positionID === positionID) : selectedPosition
      const positionToCheck = position ? position : selectedPosition;
      // console.log("departed helper", positionToCheck);

      //Do not allow additional orders to be assigned to a driver that has already departed. (For now we just check to see if they have a completed stop to determine this)
      return positionToCheck?.stops.some((stop) => {
        return stop.status === dedicatedOrderStatuses.completed;
      });
      // toast.error("It seems the driver has already departed."); // display the error message on dragend instead
    },
    [selectedPosition],
  );

  const unAssignStop = (orderId, triggerMapUpdate) => {
    //To unassign a manual stop, the user needs to press x on it, as it was not an order to begin with.
    //If this function is called through dragging, do nothing if the stop is a manual one.

    let isManualOrder;
    setPositions((prev) => {
      const newDrivers = [...prev];
      return newDrivers.map((position) => {
        if (position.positionID === selectedPositionID) {
          // console.log("orderToRemove", order);
          const stopToUnassignIndex = position.stops.findIndex(
            (stop) => stop.deliveryId === orderId,
          );
          isManualOrder = position.stops.find(
            (order) => order.deliveryId === orderId,
          )?.isManual;
          const newStops = [...position.stops];
          newStops.splice(stopToUnassignIndex, 1);
          return {
            ...position,
            stops: newStops,
          };
        } else {
          return position;
        }
      });
    });
    // console.log("why do manual stops crash here", isManualOrder);
    // If a manual order just return after deleting it from the stops
    if (isManualOrder) {
      // console.log("IS MANUAL");
      return;
    }
    setOrders((prev) => {
      // return prev.filter((order) => order.deliveryId !== event.active.id);
      return prev.map((order) => {
        if (order.deliveryId === orderId) {
          return { ...order, assignedTo: null, hidden: false };
        } else {
          return order;
        }
      });
    });
    if (triggerMapUpdate) {
      setMapUpdateNotifier((prev) => prev + 1);
    }
  };

  const orderOnClick = (e, orderToAssign) => {
    // Multiselect for ctrl to select multiple or shift to select range WIP
    // if (e.ctrlKey) {
    //   selectOrder(orderToAssign.deliveryId);
    // }
  };
  const onAssignOrderClick = (e, orderToAssign) => {
    e.stopPropagation();
    //Moved inside handleAssignOrderToPosition function
    // if (!selectedPositionID) {
    //   toast.error(`No ${positionTermLowerCase} selected.`);
    //   return;
    // }
    handleAssignOrdersToPosition([orderToAssign]);
  };

  //returns true/false whether it was successfully added or not
  const handleAssignOrdersToPosition = useCallback(
    (ordersToAssign, positionID, isManual, sequenceNumber) => {
      // console.log("orders to assign", ordersToAssign);
      // console.log("positionID", positionID);
      // console.log("isManual", isManual);
      // console.log("Sequence number", sequenceNumber);
      //To keep logic consistent, let's just wrap the order in an array if it's not already pre-wrapped, instead of doing different condition logic each time
      const ordersToAssignArray = Array.isArray(ordersToAssign)
        ? ordersToAssign
        : [ordersToAssign];
      //If no position is selected and one wasn't passed in, fail to add the order
      if (!selectedPositionID && !positionID) {
        toast.error(`No ${positionTermLowerCase} selected.`);
        return false;
      }
      const positionIDToAssign = positionID ?? selectedPositionID; //if a position ID was passed, use that, otherwise use the current selected position
      const positionToAssignTo = positions.find(
        (position) => position.positionID === positionIDToAssign,
      );

      if (determinePositionHasDeparted(positionToAssignTo)) {
        //if the position has already left and we are trying to add a delivery, fail (but pickups are ok), as the package is not on the driver's truck and he has already left.
        if (
          ordersToAssignArray.some((orderToAssign) => {
            return (
              parseInt(orderToAssign.stopType) !== CXTStopTypes.pickup.value
            );
          })
        ) {
          toast.error(dispatchErrorMessages.driverDeparted);
          return false;
        } else {
          // console.log(
          //   "latest completed stop number",
          //   physicalStopData.latestCompletedOrderPhysicalStopNumber
          // );
          //sequenceNumber is 0 based so no need to do <= or we could omit the + 1 to the physicalstop number instead,
          if (
            sequenceNumber <
            physicalStopData.latestCompletedOrderPhysicalStopNumber + 1 //if we are trying to insert before the "Next Up" stop
          ) {
            toast.error(
              `New stops cannot be assigned before next up stop. (${
                physicalStopData?.latestCompletedOrderPhysicalStopNumber + 1
              })`,
            );
            return false;
          }
        }
      }
      if (!determinePositionRunsOnCurrentDay(positionToAssignTo)) {
        toast.error(
          `The selected ${positionTermLowerCase} does not run today.`,
          {
            autoClose: 3000,
            hideProgressBar: true,
          },
        );
        return false;
      }
      if (sequenceNumber || sequenceNumber === 0) {
        // console.log("MANUAL STOP HAS SEQUENCE NUMBER - ASSIGNING");
        setPositions((prev) => {
          //*TODO Forgot why is copied the array over. Might be able to skip this to improve performance
          const newPositions = [...prev];
          return newPositions.map((position) => {
            if (position.positionID === positionIDToAssign) {
              const newStops = [...position.stops];
              newStops.splice(
                sequenceNumber,
                0,
                ...ordersToAssignArray.map((orderToAssign) => {
                  return {
                    ...orderToAssign,
                    assignedTo: positionIDToAssign,
                  };
                }),
              );
              return {
                ...position,
                stops: newStops,
              };
            } else {
              return position;
            }
          });
        });
      } else {
        setPositions((prev) => {
          //*TODO Forgot why is copied the array over. Might be able to skip this to improve performance
          const newPositions = [...prev];
          return newPositions.map((position) => {
            if (position.positionID === positionIDToAssign) {
              // console.log("orderToAdd", orderToAssign);
              return {
                ...position,
                stops: [
                  ...position.stops,
                  ...ordersToAssignArray.map((orderToAssign) => {
                    return {
                      ...orderToAssign,
                      assignedTo: positionIDToAssign,
                    };
                  }),
                ],
              };
            } else {
              return position;
            }
          });
        });
      }
      //Make sure the orders have a assignedTo field in the original orders array so they don't show up as unassigned still.
      if (!isManual) {
        const assignedDeliveryIds = {};
        for (let i = 0; i < ordersToAssignArray.length; i++) {
          assignedDeliveryIds[ordersToAssignArray[i].deliveryId] = true;
        }
        // console.log(assignedDeliveryIds);
        setOrders((prev) => {
          // return prev.filter((order) => order.deliveryId !== event.active.id);
          return prev.map((order) => {
            // console.log(assignedDeliveryIds[order.deliveryId]);
            // if (order.deliveryId === ordersToAssign.deliveryId) {
            if (assignedDeliveryIds[order.deliveryId]) {
              return { ...order, hidden: true, assignedTo: positionIDToAssign };
            } else {
              return order;
            }
          });
        });

        // setOrders((prev) =>
        //   prev.filter(
        //     (prevOrder) => prevOrder.deliveryId !== order.deliveryId
        //   )
        // );
      }
      //MAYBE JUST REPLACE BELOW WITH A FLAG FOR SHOULDUPDATEMAP? *POTENTIAL IMPROVEMENT
      //If we added an order by clicking the assign button (no positionID passed)
      //or we dragged an order onto a driver we are already viewing, update the map
      if (!positionID || positionID === selectedPositionID || isManual) {
        // console.log("SHOULD UPDATE MAP");
        setMapUpdateNotifier((prev) => prev + 1);
      }
      return true;
    },
    [
      selectedPositionID,
      determinePositionHasDeparted,
      physicalStopData.latestCompletedOrderPhysicalStopNumber,
      positionTermLowerCase,
      positions,
      setPositions,
      setOrders,
    ],
  );
  //For dragging and dropping an already assigned order/stop to another driver directly.
  const handleAssignStopToPosition = (stopToAssign, positionIDToAssignTo) => {
    if (!positionIDToAssignTo) {
      return;
    }
    if (selectedPositionID === positionIDToAssignTo) {
      return;
    }
    const positionToAssignTo = positions.find(
      (position) => position.positionID === positionIDToAssignTo,
    );
    if (!determinePositionRunsOnCurrentDay(positionToAssignTo)) {
      toast.error(`The selected ${positionTermLowerCase} does not run today.`, {
        autoClose: 3000,
        hideProgressBar: true,
      });
      return;
    }
    setPositions((prev) => {
      const newPositions = [...prev];
      return newPositions.map((position) => {
        if (position.positionID === positionIDToAssignTo) {
          // console.log("orderToAdd", orderToAssign);
          return {
            ...position,
            stops: [
              ...position.stops,
              { ...stopToAssign, assignedTo: positionIDToAssignTo },
            ],
          };
        } else if (position.positionID === selectedPositionID) {
          const orderToDeleteIndex = position.stops.findIndex(
            (order) => order.deliveryId === stopToAssign.deliveryId,
          );
          const newStops = [...position.stops];
          newStops.splice(orderToDeleteIndex, 1);
          return {
            ...position,
            stops: newStops,
          };
        } else {
          return position;
        }
      });
    });
    setOrders((prev) => {
      return prev.map((order) => {
        if (order.deliveryId === stopToAssign.deliveryId) {
          return {
            ...order,
            // hidden: true, //this is already true in the orders array as we are assigning an already assigned order to a different driver
            assignedTo: positionIDToAssignTo,
          };
        } else {
          return order;
        }
      });
    });
    //If we assigned the stop to a different driver update the map as it was removed
    if (positionIDToAssignTo !== selectedPositionID) {
      setMapUpdateNotifier((prev) => prev + 1);
    }
  };

  // const [orderIDBeingDragged, setOrderIDBeingDragged] = useState();
  // const [currentDraggableType, setCurrentDraggableType] = useState();
  const [draggingData, setDraggingData] = useState({
    id: null,
    draggableType: null,
    assignedTo: null,
    isDraggingManualOrder: null,
    stopNumber: null,
    physicalStopNumber: null,
  });

  // console.log("current dragging data", draggingData);

  const handleDragStart = (event) => {
    // console.log("drag started", event);
    setDraggingData({
      id: event.active.id,
      draggableType: event.active.data?.current?.draggableType,
      isDraggingManualOrder: isManualStopBasedOnId(event.active.id),
      assignedTo: event.active.data?.current?.assignedTo,
      stopNumber: event.active.data?.current?.stopNumber,
      physicalStopNumber: event.active.data?.current?.physicalStopNumber,
    });
    // setOrderIDBeingDragged(event.active.id);
    // setCurrentDraggableType(event.active.data.current.draggableType);
  };
  const handleDragCancel = (event) => {
    resetDraggingData();
  };

  const resetDraggingData = () => {
    setDraggingData({
      id: null,
      draggableType: null,
      assignedTo: null,
      isDraggingManualOrder: null,
      stopNumber: null,
      physicalStopNumber: null,
    });
  };

  const dropCases = {
    orderDragCancel: "orderDragCancel", // Basically cancelling. I.e. user starts dragging an order but drags it back because they changed their mind.
    stopDragCancel: "stopDragCancel",
    orderToDriverDirect: "orderToDriverDirect", // Assigning an order to a driver by dragging onto the driver, without dragging into their stops. Should assign the order to their latest stop.
    orderToStopDropzone: "orderToStopDropzone", // Used to moves an unassigned order into a driver's stops array on drag over. They can decide the order before ending the drop.
    orderToStopReorder: "orderToStopReorder", // assigned an order to a driver that already has stops assigned, into the index of the position it was dragged into. I.e. if the driver has 5 stops assigned already, and the user drags an order over stop 3 it should insert the new order into stop 3 and move stops 3, 4, 5  to 4, 5, 6
    stopToStopReorder: "stopToStopReorder", //Used for reoordering stops
    stopToDriverDirect: "stopToDriverDirect", // Assigns a stop to another driver (adds it as their latest stop)
    stopToOrderDropzone: "stopToOrderDropzone", // Unassigns the order.
    stopToOrderReorder: "stopToOrderReorder",
    stopToStopDropzone: "stopToStopDropzone", //When a stop is dropped on a stop dropzone. This happens because after dragging an order over the stops dropzone that order is now a stop. When you drop that stop it now counts as this.
    orderToOrderDropzone: "orderToOrderDropzone",
    orderToOrderReorder: "orderToOrderReorder",
    // stopToLap //if we implement multiple laps, we might want the ability to drag stops between laps.
  };
  const determineDropCase = (event) => {
    //anything marked FOR DRAG END is because before we handled most things ondragover. Most things are converted ondragover (i.e. orders become stops when dragged over onto the stopsdropzone or a stop, vice versa) and the on drop events need to take that into account.
    //started by dragging an order
    //Order to stop dropzone. I.e. When an order is dragged over an empty stops list or to the very end of a stops list.
    if (
      event.active.data?.current?.draggableType === draggableTypes.order &&
      event.over.id === dropTypes.stopsDropzone
    ) {
      return dropCases.orderToStopDropzone;
    }
    //When a stop is dropped on a stop dropzone. This happens because after dragging an order over the stops dropzone that order is now a stop. When you drop that stop it now counts as this.
    if (
      //for drag end
      event.active.data?.current?.draggableType === draggableTypes.stop &&
      event.over.id === dropTypes.stopsDropzone
    ) {
      return dropCases.stopToStopDropzone;
    }
    //Order to stop Reorder. I.e. When an order is dragged over stops, it inserts it directly into them at that location
    if (
      event.active.data?.current?.draggableType === draggableTypes.order &&
      event.over.data?.current?.draggableType === draggableTypes.stop
    ) {
      return dropCases.orderToStopReorder;
    }
    if (
      event.active.data?.current?.draggableType === draggableTypes.order &&
      event.over.data?.current?.dropType === dropTypes.driverDirectDrop
    ) {
      return dropCases.orderToDriverDirect;
    }
    //started by dragging a stop
    if (
      event.active.data?.current?.draggableType === draggableTypes.stop &&
      event.over.data?.current?.draggableType === draggableTypes.stop
    ) {
      return dropCases.stopToStopReorder;
    }
    if (
      event.active.data?.current?.draggableType === draggableTypes.stop &&
      event.over.id === dropTypes.ordersDropzone
    ) {
      return dropCases.stopToOrderDropzone;
    }
    if (
      //for drag end //unassigning stop when there are no orders so it is over the orderdropzone but stop becomes order on dragover
      event.active.data?.current?.draggableType === draggableTypes.order &&
      event.over.id === dropTypes.ordersDropzone
    ) {
      return dropCases.orderToOrderDropzone;
    }
    if (
      //for drag end
      event.active.data?.current?.draggableType === draggableTypes.order &&
      event.over.data?.current?.draggableType === draggableTypes.order
    ) {
      return dropCases.orderToOrderReorder;
    }
    if (
      event.active.data?.current?.draggableType === draggableTypes.stop &&
      event.over.data?.current?.draggableType === draggableTypes.order
    ) {
      return dropCases.stopToOrderReorder; //currently not re-ordering, just un-assigning.
    }
    if (
      event.active.data?.current?.draggableType === draggableTypes.stop &&
      event.over.data?.current?.dropType === dropTypes.driverDirectDrop
    ) {
      return dropCases.stopToDriverDirect;
    }
  };

  /**
   * {
   * driver:5315,
   * [{
   * order:3,
   * fromDriver:5931
   * }]
   * }
   */
  const [switchDriverCache, setSwitchDriverCache] = useState({
    //making a separate cache for this as it *may* need a lot of changes and managing done to work the way it is now. And we may change it to just remove the order and treat it as unassigned before switching drivers instead and have to undo this work.
  });
  const selectedPositionHasOrdersBeingSwitched = useMemo(() => {
    return selectedPositionID
      ? Object.values(switchDriverCache)
          .map((switchDriverCacheObject) => {
            return switchDriverCacheObject.from;
          })
          .includes(selectedPositionID)
      : false;
  }, [switchDriverCache, selectedPositionID]);
  // console.log(
  //   "Selected position has orders being switched",
  //   selectedPositionHasOrdersBeingSwitched
  // );
  // console.log("switch driver cache", switchDriverCache);

  const handleDragEnd = (event) => {
    // console.log("drag\n\nend\n\nevent");
    // console.log(event);
    // console.log(event.activatorEvent.currentTarget);
    // console.log(event.activatorEvent.relatedTarget);
    if (event.over.data?.current?.draggableType !== draggableTypes.stop) {
      setHoveredStop(null);
    }
    // if(event.activatorEvent.target)
    const dropCase = determineDropCase(event);

    const orderID = event.active.id;
    const positionIDTo = event.over.id; //the ID of the position we dragged over/to.
    const dropType = event.over.data?.current?.dropType;
    // console.log("drag ended", event);
    if (dropType === dropTypes.driverDirectDrop) {
      const isActivePosition = event.over.data?.current?.active;
      if (!isActivePosition) {
        toast.error(`This ${positionTermLowerCase} does not run today.`);
        return;
      }
      if (dropCase === dropCases.orderToDriverDirect) {
        setPositionMapCache((prev) => {
          return {
            ...prev,
            [positionIDTo]: {
              ...(prev[positionIDTo] ?? {}),
              dirty: true,
            },
          };
        });
        handleAssignOrdersToPosition(
          orders.filter((order) => order.deliveryId === orderID),
          positionIDTo,
        );
        // //an order was assigned to the driver/position we are viewing, so update the map
        // if(positionID === selectedPositionID){
        //   setMapUpdateNotifier(prev=>prev+1)
        // }
      }
      if (dropCase === dropCases.stopToDriverDirect) {
        const stopToDriverFunction = (
          switchedDriverForSubmittedOrder,
          isSwitchBack,
        ) => {
          setPositionMapCache((prev) => {
            return {
              ...prev,
              //The driver the order was switched to,
              [positionIDTo]: {
                ...(prev[positionIDTo] ?? {}),
                dirty: true,
              },
              [selectedPositionID]: {
                //The original driver if we switched a submitted order from it. Only used because when we switch a submitted order to a different driver, the to driver was marked dirty, and it would auto switch to the to driver and update the map, but the original driver's map doesn't update, so we mark it dirty here.
                ...(prev[selectedPositionID] ?? {}),
                dirty: switchedDriverForSubmittedOrder ?? false,
              },
            };
          });
          if (switchedDriverForSubmittedOrder) {
            //take into account switching back
            //If this was an order switched to this driver and we are dragging it back to the position it was switched from
            if (isSwitchBack) {
              setSwitchDriverCache((prev) => {
                const newOrders = switchDriverCache[
                  selectedPositionID
                ].orders.filter((order) => order !== orderID);
                //if the position has no switched orders left, null it out
                if (newOrders.length === 0) {
                  return {
                    ...prev,
                    [selectedPositionID]: { orders: [], from: null },
                  };
                } else {
                  //else update the driver's switchDriverCache with the reduced orders
                  return {
                    ...prev,
                    [selectedPositionID]: {
                      ...switchDriverCache[selectedPositionID],
                      orders: newOrders,
                    },
                  };
                }
              });
            } else {
              //If not a switch back, set up the drivers switchDriverCache
              //take into account transitioning from one non original driver to another
              if (
                switchDriverCache[selectedPositionID]?.orders?.includes(
                  orderID,
                ) &&
                switchDriverCache[selectedPositionID]?.from !== positionIDTo
              ) {
                //if we are transitioning a previously switched order to another driver it didn't originate from
                const fromDriverID =
                  switchDriverCache[selectedPositionID]?.from;
                setSwitchDriverCache((prev) => {
                  const newOrdersForDriverSwitchingOut = switchDriverCache[
                    selectedPositionID
                  ]?.orders?.filter((order) => order !== orderID);
                  return {
                    ...prev,
                    [selectedPositionID]: {
                      orders: newOrdersForDriverSwitchingOut,
                      from:
                        newOrdersForDriverSwitchingOut?.length > 0
                          ? switchDriverCache[selectedPositionID]?.from
                          : null,
                    },
                    [positionIDTo]: {
                      orders: [...(prev[positionIDTo]?.orders ?? []), orderID],
                      from: fromDriverID,
                    },
                  };
                });
              } else {
                //Not a switchback, not a transition
                //But an actual first time switch
                setSwitchDriverCache((prev) => {
                  return {
                    ...prev,
                    [positionIDTo]: {
                      orders: [...(prev[positionIDTo]?.orders ?? []), orderID],
                      from: selectedPositionID,
                    },
                  };
                });
              }
            }
          }
          //handleAssignStopToPosition updates the map
          handleAssignStopToPosition(
            orders.find((order) => order.deliveryId === orderID),
            positionIDTo,
          );
        };
        if (
          event.active.data.current.status !==
          dedicatedOrderStatuses.unSubmitted
        ) {
          //Prevent switching orders from more than one driver to a single driver (for now)
          if (
            switchDriverCache[positionIDTo]?.from &&
            switchDriverCache[positionIDTo].from !== selectedPositionID
          ) {
            toast.error(
              `The target ${[
                positionTermLowerCase,
              ]} has ${orderTermLowerCase}s belonging to another ${positionTermLowerCase}. Please submit changes on the target ${positionTermLowerCase} before attempting to switch ${orderTermLowerCase}s from a third ${positionTermLowerCase} to it.`,
            );
            return;
          }
          //Prevent switching order away from a driver that has an order already switched to it (for now)
          if (
            switchDriverCache[selectedPositionID]?.orders.length > 0 &&
            !switchDriverCache[selectedPositionID]?.orders?.includes(orderID)
          ) {
            toast.error(
              `Please submit switched ${orderTermLowerCase}s on this ${positionTermLowerCase} before attempting to switch its submitted ${orderTermLowerCase}s to another ${positionTermLowerCase}.`,
            );
            return;
          }
          //Prevent switching orders onto a driver that has one of it's orders switched away
          if (
            Object.entries(switchDriverCache).find((switchDriverCacheEntry) => {
              return (
                switchDriverCacheEntry[1].from === positionIDTo &&
                switchDriverCacheEntry[0] !== "" + selectedPositionID //convert positionIDTo to string, because the object.entries keys are strings and positionIDs are originally integers.
              );
            })
          ) {
            toast.error(
              `The target ${positionTermLowerCase} already has pending ${orderTermLowerCase}s that have been switched to a different ${positionTermLowerCase}. Please submit that other ${positionTermLowerCase} before attempting to switch ${orderTermLowerCase}s between these two.`,
            );
            return;
          }
          //Prevent switching orders from one driver to multiple different drivers (for now)
          if (
            Object.entries(switchDriverCache).find((switchDriverCacheEntry) => {
              return (
                switchDriverCacheEntry[1].from === selectedPositionID &&
                switchDriverCacheEntry[0] !== "" + positionIDTo //convert positionIDTo to string, because the object.entries keys are strings and positionIDs are originally integers.
              );
            })
          ) {
            toast.error(
              `The source ${positionTermLowerCase} already has pending ${orderTermLowerCase}s that have been switched to a different ${positionTermLowerCase}. Please submit that other ${positionTermLowerCase} before attempting to switch ${orderTermLowerCase}s between these two.`,
            );
            return;
          }
          //Prevent transitioning a switched order from 1 driver to another that is not the original, if there is more than one (for now)
          if (
            switchDriverCache[selectedPositionID]?.orders?.length > 1 &&
            switchDriverCache[selectedPositionID]?.orders?.includes(orderID) &&
            switchDriverCache[selectedPositionID]?.from !== positionIDTo
          ) {
            toast.error(
              `Transitioning switched ${orderTermLowerCase}s is disabled when more than one ${orderTermLowerCase} is pending switch. Please submit or cancel some of your changes first.`,
            );
            return;
          }
          if (
            switchDriverCache[selectedPositionID]?.orders?.includes(orderID) &&
            switchDriverCache[selectedPositionID]?.from === positionIDTo
          ) {
            stopToDriverFunction(true, true);
          } else {
            initiateSwitchDriver(() => {
              stopToDriverFunction(true);
            }, positionIDTo);
          }
        } else {
          stopToDriverFunction();
        }
      }
    }
    // console.log("switch driver cache", switchDriverCache);

    // console.log(event);
    //For Assigning:
    // This is never the case on drag end as the drag over changes orders to stops before they hit the dropzone
    // if (determineDropCase(event) === dropCases.orderToStopDropzone) {
    //   console.log("was dropped to stopdropzone");
    //   setMapUpdateNotifier((prev) => prev + 1);
    // }
    //so do this instead
    if (dropCase === dropCases.stopToStopDropzone) {
      // console.log("stop to stopdropzone");
      setMapUpdateNotifier((prev) => prev + 1);
    }
    if (dropCase === dropCases.orderToStopReorder) {
      if (determinePositionHasDeparted()) {
        toast.error(dispatchErrorMessages.driverDeparted);
        return;
      }
      if (attemptedToDragBetweenCompletedOrNextUp(event)) {
        return;
      }
      // console.log("order to stop reorder");
      setMapUpdateNotifier((prev) => prev + 1);
    }
    //Dragging over takes care of adding the orders in this case, but if there was a reason not to add the order on drag, display the error message on drag end.
    if (dropCase === dropCases.orderToStopDropzone) {
      if (determinePositionHasDeparted()) {
        toast.error(dispatchErrorMessages.driverDeparted);
        return;
      }
      // Do not update the map here as we convert the order to a stop on drag over of the stopdropzone. So the map updates in the stopToStopDropzone/stopToStopReorder take care of it.
      // setMapUpdateNotifier((prev) => prev + 1);
    }
    //For reordering:
    if (dropCase === dropCases.stopToStopReorder) {
      // console.log("stop to stop reorder");
      // console.log(event.over?.data?.current?.sortable?.index);
      // console.log("drag over for stop reorder ran");
      const activeItemData = event.active?.data?.current;
      const overItemData = event.over?.data?.current;
      //the drag over is called even something is dragged onto itself. In that case we want to prevent the logic from running.
      //What ends up happening is that it runs this logic on drag start as it hovers over itself in that moment
      //And then when switching places with another element it gets run once for hovering over the other element (as it should),
      //and then AGAIN, as after the elements switch, it hovers over itself again in that moment.
      //Returning here prevents the map updating when an order is dragged over into the stops side and dropped onto where it was dragged over, So basically most times. Need to figure this out, probably will check if any change was detecting in the map route function itself.
      // if (activeItemData === overItemData) {
      //   //TODO, I realized this is an object check later on which might not work correctly. Comparing the ids might be safer but the overlay might have a suffix that needs to be removed. Not 100% sure.
      //   // Could use the draggingdata state to check instead of the activeItemData's id possibly. But it seems to work fine for now and we switched to update the map on drop anyway.
      //   return;
      // }
      if (attemptedToDragBetweenCompletedOrNextUp(event)) {
        return;
      }
      setPositions((prev) => {
        return prev.map((driver) => {
          if (driver.positionID === selectedPositionID) {
            const activeItemData = event.active?.data?.current;
            const overItemData = event.over?.data?.current;
            const currentStops = driver.stops;
            const reorderedStops = arrayMove(
              currentStops,
              activeItemData?.sortable.index,
              overItemData?.sortable.index,
            );
            // console.log(currentStops);
            // return driver;
            return {
              ...driver,
              stops: reorderedStops,
            };
          } else {
            return driver;
          }
        });
      });
      setMapUpdateNotifier((prev) => prev + 1);
    }

    //For Unassigning on drop:
    // if (dropCase === dropCases.stopToOrderReorder) {
    //   console.log("stop to order reorder");

    //   setMapUpdateNotifier((prev) => prev + 1);
    // }
    // if (dropCase === dropCases.stopToOrderDropzone) {
    //   console.log("stop to order dropzone");

    //   setMapUpdateNotifier((prev) => prev + 1);
    // }
    //They get converted to orders on drag over so need to do these instead:
    if (dropCase === dropCases.orderToOrderReorder) {
      // console.log("stop to order reorder");

      setMapUpdateNotifier((prev) => prev + 1);
    }
    if (dropCase === dropCases.orderToOrderDropzone) {
      // console.log("stop to order dropzone");

      setMapUpdateNotifier((prev) => prev + 1);
    }

    //For all drop cases:
    resetDraggingData();
    // setDraggingData({ id: null, draggableType: null });

    // setOrders((prev) => {
    //   return prev
    //     .map((order) => {
    //       return { ...order, hidden: false };
    //     })
    //     .filter((order) => order.deliveryId !== event.active.id);
    // });
  };
  const handleDragOver = (event) => {
    // console.log("f302", event);
    // console.log("drag over", event);
    // console.log(determineDropCase(event));
    const dropCase = determineDropCase(event);
    if (dropCase === dropCases.orderToStopDropzone) {
      if (determinePositionHasDeparted()) {
        // toast.error("It seems the driver has already departed."); // display the error message on dragend instead
        return;
      }
      // console.log("running for", selectedPositionID);
      setPositions((prev) => {
        return prev.map((driver) => {
          if (driver.positionID === selectedPositionID) {
            if (
              driver.stops.findIndex(
                (stop) => stop.deliveryId === event.active.id,
              ) === -1
            ) {
              return {
                ...driver,
                stops: [
                  ...driver.stops,
                  orders.find((order) => {
                    return order.deliveryId === event.active.id;
                  }),
                ],
              };
            } else {
              return driver;
            }
          } else {
            return driver;
          }
        });
      });
      setOrders((prev) => {
        // return prev.filter((order) => order.deliveryId !== event.active.id);
        return prev.map((order) => {
          if (order.deliveryId === event.active.id) {
            return { ...order, assignedTo: selectedPositionID, hidden: true };
          } else {
            return order;
          }
        });
      });
    }
    if (dropCase === dropCases.orderToStopReorder) {
      if (determinePositionHasDeparted()) {
        // toast.error("It seems the driver has already departed."); // display the error message on dragend instead
        return;
      }
      if (attemptedToDragBetweenCompletedOrNextUp(event)) {
        return;
      }
      setPositions((prev) => {
        return prev.map((driver) => {
          if (driver.positionID === selectedPositionID) {
            const currentStops = [...driver.stops];
            // if(event.over?.data?.current?.sortable?.index === driver.stops.length){

            // }
            currentStops.splice(
              event.over?.data?.current?.sortable?.index,
              0,
              orders.find((order) => {
                return order.deliveryId === event.active.id;
              }),
            );
            if (
              driver.stops.findIndex(
                (stop) => stop.deliveryId === event.active.id,
              ) === -1
            ) {
              return {
                ...driver,
                stops: currentStops,
              };
            } else {
              return driver;
            }
          } else {
            return driver;
          }
        });
      });
      setOrders((prev) => {
        // return prev.filter((order) => order.deliveryId !== event.active.id);
        return prev.map((order) => {
          if (order.deliveryId === event.active.id) {
            return { ...order, assignedTo: selectedPositionID, hidden: true };
          } else {
            return order;
          }
        });
      });
      // requestAnimationFrame(() => {}); //Had this here before but just calling it in a useEffect for now. Might move to each event that would need it instead like this and the route mapping call
    }
    if (dropCase === dropCases.stopToStopReorder) {
      //Moved this entirely to onDragend, to help with performance. Also allows the ability to cancel a reorder with escape/right click without having to code an undo. Downside is the stop being dragged does not update its stop number live. Though another positive is previously we had a modified badge I took out due to it showing while dragging on all orders switched which would look a little disorienting as well as cause resizedObserver loop errors due to it changing the heights of the stops during drag.
    }
    if (dropCase === dropCases.stopToOrderDropzone) {
      if (
        draggingData?.isDraggingManualOrder ||
        event.active.data.current.status !== dedicatedOrderStatuses.unSubmitted //Eventually we want to add cancellations but We did not get there yet.
      ) {
        return;
      }
      unAssignStop(event.active.id);
    }
    if (dropCase === dropCases.stopToOrderReorder) {
      if (
        draggingData?.isDraggingManualOrder ||
        event.active.data.current.status !== dedicatedOrderStatuses.unSubmitted //Eventually we want to add cancellations but We did not get there yet.
      ) {
        return;
      }
      unAssignStop(event.active.id);
    }
  };

  const orderToDisplayForDragOverlay =
    orders.find((order) => {
      return order.deliveryId === draggingData.id;
    }) ??
    selectedPosition?.stops.find((order) => {
      return order.deliveryId === draggingData.id;
    });
  // const dragOverlayOrderToDisplay =
  //   draggingData.draggableType === draggableTypes.order
  //     ? orders.find((order) => {
  //         return order.deliveryId === draggingData.id;
  //       })
  //     : selectedPosition?.stops.find((order) => {
  //         return order.deliveryId === draggingData.id;
  //       });
  // console.log("dragging data", draggingData.draggableType);
  // console.log(dragOverlayOrderToDisplay);

  //We need to request animation frame on dragging an item from one container to another to keep the dragged item held or else it just disappears on move.
  useEffect(() => {
    requestAnimationFrame(() => {});
  }, [orders]);

  const [selectedOrderIDs, setSelectedOrderIDs] = useState([]);

  const selectOrder = (orderID) => {
    setSelectedOrderIDs((prev) => {
      if (prev.includes(orderID)) {
        return prev.filter((prevOrderID) => prevOrderID !== orderID);
      } else {
        return [...prev, orderID];
      }
    });
  };

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [orderToShowDetailsFor, setOrderToShowDetailsFor] = useState();
  const handleShowDetailsModal = (e, order) => {
    // console.log("DETAILS CLICKED");
    e.stopPropagation();
    setOrderToShowDetailsFor(order);
    setShowDetailsModal(true);
  };
  const handleCloseDetailsModal = () => {
    // setOrderToShowDetailsFor();
    setShowDetailsModal(false);
  };

  const [showAddManualStopModal, setShowAddManualStopModal] = useState(false);
  const handleShowAddManualStopModal = () => {
    setShowAddManualStopModal(true);
  };
  const handleCloseAddManualStopModal = () => {
    setShowAddManualStopModal(false);
  };

  // {
  // posId:{markers:{}, route:{}, simpleRoute{}}
  // }
  const [allMarkers, setAllMarkers] = useState([]);
  const [collapsedState, setCollapsedState] = useState(
    collapsedStates.full.value,
  );

  const [viewUnassigned, setViewUnassigned] = useState(false);

  const groupedOrderEntries = useMemo(() => {
    return Object.entries(
      orders
        // .slice(0, 20)
        .filter((order) => {
          // console.log(order);
          return !order.assignedTo;
          // && order?.address?.includes("GASTON");
        })
        .reduce((uniqueDestinationInfoBuilder, currentOrder) => {
          // console.log("assigned to", currentOrder.assignedTo);
          if (currentOrder.assignedTo) {
            // If the order is already assigned, just skip it
            return uniqueDestinationInfoBuilder;
          }
          const stopAddressKey = currentOrder.locationKey;
          // if (unassignedLocationsThatAlreadyHaveMarkerData[stopAddressKey]) {
          //   return uniqueDestinationInfoBuilder;
          // }
          if (uniqueDestinationInfoBuilder[stopAddressKey]) {
            const destinationWithInfo =
              uniqueDestinationInfoBuilder[stopAddressKey];
            uniqueDestinationInfoBuilder[stopAddressKey] = {
              ...destinationWithInfo,
              numOrders: destinationWithInfo.numOrders + 1,
              orders: [
                ...destinationWithInfo.orders,
                {
                  invoiceNumber: currentOrder.invoiceNumber,
                  deliveryId: currentOrder.deliveryId,
                  order: currentOrder,
                  numberOfParts: currentOrder.numberOfParts,
                },
              ],
            };
          } else {
            uniqueDestinationInfoBuilder[stopAddressKey] = {
              name: currentOrder.customerName,
              destination: currentOrder.locationString,
              destinationWithoutName: currentOrder.locationStringWithoutName,
              numOrders: 1,
              orders: [
                {
                  invoiceNumber: currentOrder.invoiceNumber,
                  deliveryId: currentOrder.deliveryId,
                  order: currentOrder,
                  numberOfParts: currentOrder.numberOfParts,
                },
              ],
            };
          }
          return uniqueDestinationInfoBuilder;
        }, {}),
    );
  }, [orders]);
  const geocodedDestinationQueries = useQueries({
    queries: groupedOrderEntries.map((entry) => {
      return {
        queryKey: ["geocodedDestination", entry[0]], //[0] is the location key
        queryFn: async () => {
          try {
            // console.log("Ran query function");
            const orderLocationKey = entry[0];
            const geocodedLocationResponse = await getGeoCoordinatesForAddress(
              entry[1]?.destination, //special symbols need to be url encoded. e.g. #, &. (handle this in the function itself now)
            );
            const location =
              geocodedLocationResponse.data.results[0].geometry.location;
            return {
              key: "Unassigned-" + orderLocationKey,
              locationKey: orderLocationKey,
              //pass glyph or glyphtype, if you are going to have multiple markers with the same glyph, prefer glyph type so we are not storing an icon for each element in memory and generating on the fly instead
              glyphType: glyphTypes.package.type,
              location: location,
              assigned: false,
              data: {
                name: entry[1]?.name,
                address: entry[1].destinationWithoutName,
                // numOrders: entry[1]?.numOrders,
              },
              markerProps: {
                color: "darkgray",
                customGlyphColor: "darkgray",
                hoveredColor: "rgb(120,120,120)",
              },
            };
          } catch (ex) {
            //Suppressing individual errors.
            if (ex.status === 401) {
              //Maybe do something else if the error was a 401 error, e.g. log out
              // handleApiError(ex);
              // toast.warn("if statement worked");
            } else {
            }
            return { locationKey: entry[0], isError: true };
          }
        },
        select: (data) => {
          // console.log("select data", data);
          return {
            ...data,
            data: {
              ...data.data,
              numOrders: entry[1]?.numOrders,
              orders: entry[1]?.orders,
            },
          };
        },
        staleTime: 12 * 1000 * 60 * 60, //12 hours, since location data from google shouldn't change often anyway and want to save on API calls.
        enabled: viewUnassigned,
      };
    }),
  });
  // console.log(
  //   "view unassigned - Geocoded Destination Queries",
  //   geocodedDestinationQueries
  // );
  const viewUnassignedData = useMemo(() => {
    // console.log("view unassigned data memo ran");
    let successfulQueries = [];
    let loadingQueries = 0;
    let failedQueryLocationKeys = {};
    for (let i = 0; i < geocodedDestinationQueries.length; i++) {
      if (geocodedDestinationQueries[i].isLoading) {
        loadingQueries++;
      }
      if (geocodedDestinationQueries[i].data?.isError) {
        // console.log("failed query", geocodedDestinationQueries[i]);
        failedQueryLocationKeys[
          geocodedDestinationQueries[i].data?.locationKey
        ] = true;
      } else {
        if (geocodedDestinationQueries[i].isSuccess) {
          successfulQueries.push(geocodedDestinationQueries[i]?.data);
        }
      }
    }
    const allQueriesSuccessful =
      geocodedDestinationQueries.length === successfulQueries.length;
    const destinationMarkers = successfulQueries?.map((query) => {
      return query.data;
    });
    return {
      loadingAmount: loadingQueries.length,
      allQueriesSuccessful: allQueriesSuccessful,
      destinationMarkers: successfulQueries,
      failedGeolocationsLookupObj: failedQueryLocationKeys,
    };
  }, [geocodedDestinationQueries]);

  // console.log("geocodeddestinationqueries", geocodedDestinationQueries);
  // console.log("view unassigned data", viewUnassignedData);

  const handleClickViewUnassigned = async (e) => {
    // console.log(e);
    // return;
    const previousViewUnassignedState = viewUnassigned;
    setViewUnassigned((prev) => !prev);
    //Switched following to be based off react query instead for now:
    //if the previous unassigned state was false, fetch unassigned stops
    // if (!previousViewUnassignedState) {
    //   // setLoading(true); Does not work due to the way the function is, but will refactor later

    //   const unassignedLocationsThatAlreadyHaveMarkerData = allMarkers.reduce(
    //     (
    //       unassignedLocationsThatAlreadyHaveMarkerDataBuilder,
    //       currentMarker
    //     ) => {
    //       const stopAddressKey = currentMarker.key.split("Unassigned-")[1];
    //       return {
    //         ...unassignedLocationsThatAlreadyHaveMarkerDataBuilder,
    //         [stopAddressKey]: true,
    //       };
    //     },
    //     {}
    //   );

    //   const uniqueDestinationsWithInfo = orders.reduce(
    //     (uniqueDestinationInfoBuilder, currentOrder) => {
    //       if (currentOrder.assignedTo) {
    //         // If the order is already assigned, just skip it
    //         return uniqueDestinationInfoBuilder;
    //       }
    //       const stopAddressKey = generateLocationKey(currentOrder);
    //       if (unassignedLocationsThatAlreadyHaveMarkerData[stopAddressKey]) {
    //         return uniqueDestinationInfoBuilder;
    //       }
    //       if (uniqueDestinationInfoBuilder[stopAddressKey]) {
    //         const destinationWithInfo =
    //           uniqueDestinationInfoBuilder[stopAddressKey];
    //         uniqueDestinationInfoBuilder[stopAddressKey] = {
    //           ...destinationWithInfo,
    //           numOrders: destinationWithInfo.numOrders + 1,
    //         };
    //       } else {
    //         uniqueDestinationInfoBuilder[stopAddressKey] = {
    //           name: currentOrder.customerName,
    //           destination: generateLocationString(currentOrder),
    //           numOrders: 1,
    //         };
    //       }
    //       return uniqueDestinationInfoBuilder;
    //     },
    //     {}
    //   );
    //   console.log(
    //     "view unassigned - unique destinations with info",
    //     uniqueDestinationsWithInfo
    //   );
    //   return;
    //   const uniqueDestinationsWithInfoEntries = Object.entries(
    //     uniqueDestinationsWithInfo
    //   );
    //   try {
    //     uniqueDestinationsWithInfoEntries.map(async (entry, index) => {
    //       // const geocodedLocationResponse = await mapsApiAxios.get(
    //       //   "https://maps.googleapis.com/maps/api/geocode/json",
    //       //   {
    //       //     params: {
    //       //       address: generateLocationString(order),
    //       //       key: apizk,
    //       //     },
    //       //   }
    //       // );
    //       const orderLocationString = entry[1]?.destination;
    //       const orderLocationKey = entry[0];
    //       try {
    //         // if (
    //         //   !orderLocationString.toLowerCase().includes("cho's shel") &&
    //         //   !orderLocationString.toLowerCase().includes("troy")
    //         // ) {
    //         //   return;
    //         // }
    //         const geocodedLocationResponse = await getGeoCoordinatesForAddress(
    //           orderLocationString.replace(/#/g, "%23") //special symbols need to be url encoded.
    //         );
    //         // console.log("about to access geometry");
    //         const location =
    //           geocodedLocationResponse.data.results[0].geometry.location;
    //         setAllMarkers((prev) => [
    //           ...prev,
    //           {
    //             key: "Unassigned-" + orderLocationKey,
    //             // glyph: <BiSolidPackage />,
    //             glyphType: glyphTypes.package.type,
    //             location: location,
    //             assigned: false,
    //             data: {
    //               name: entry[1]?.name,
    //               address: orderLocationString,
    //               numOrders: entry[1]?.numOrders,
    //             },
    //             markerProps: {
    //               color: "darkgray",
    //               customGlyphColor: "darkgray",
    //               hoveredColor: "darkGray",
    //             },
    //           },
    //         ]);
    //       } catch (ex) {
    //         toast.error(
    //           `Error fetching unassigned order location for ${orderLocationString}.`
    //         );
    //         // console.log("geolocation error for: " + orderLocationString, ex);
    //         // handleApiError(ex);
    //       }
    //     });
    //   } catch (ex) {
    //     toast.error("Error fetching unassigned order locations.");
    //     // handleApiError(ex);
    //   } finally {
    //     // setLoading(false);
    //   }
    // }
  };
  const [positionMapCache, setPositionMapCache] = useState({});
  // console.log("position map cache outer", positionMapCache);

  const routeTotalDurationAndDistance = getRouteTotalDurationAndDistance(
    positionMapCache?.[selectedPositionID]?.route,
  );
  // console.log("route totals - ", routeTotalDurationAndDistance);

  const [showSimpleRoute, setShowSimpleRoute] = useState(false);
  const [hoveredStop, setHoveredStop] = useState();
  const [optimizedViewTest, setOptimizedViewTest] = useState([]);

  const finishLoopBackToClient = true;
  const getMapRoutes = useCallback(
    async (shouldOptimize = true) => {
      if (!selectedPosition || selectedPosition?.stops.length < 1) {
        if (
          selectedPosition?.stops.length === 0 &&
          positionMapCache[selectedPositionID]
        ) {
          //This is to remove the last element from the cache if the last stop for a position is deleted.
          setPositionMapCache((prev) => {
            return {
              ...prev,
              [selectedPositionID]: {
                markers: [],
                route: null,
              },
            };
          });
          return;
        }
        //do nothing if there are no stops and there never were.
        return;
      }
      // console.log("OPTIMIZE RAN");
      // const uniqueDestinationsSet = new Set();
      // // const stopsToIntermediate =
      // selectedPosition?.stops.map((stop) => {
      //   uniqueDestinationsSet.add(
      //     `${stop.address} ${stop.city}, ${stop.state} ${stop.zip}`
      //   );
      //   return null;
      //   // return {
      //   //   address: `${stop.address} ${stop.city}, ${stop.state} ${stop.zip}`,
      //   // };
      // });

      let uniqueConsecutiveDestinationsWithInfo = [];
      const markerInstances = {};
      for (let i = 0; i < selectedPosition?.stops.length; i++) {
        const currentStop = selectedPosition?.stops[i];
        const currentStopKey = generateLocationKey(currentStop);
        const currentStopAddressString = generateLocationString(currentStop);
        let numConsecutiveStopsForLocation = 1;
        let nextStop =
          selectedPosition?.stops[i + numConsecutiveStopsForLocation];
        let consecutiveStartIndex = i;
        while (nextStop && currentStopKey === generateLocationKey(nextStop)) {
          numConsecutiveStopsForLocation++;
          i++;
          nextStop =
            selectedPosition?.stops[
              consecutiveStartIndex + numConsecutiveStopsForLocation
            ];
        }
        // i++;
        // numConsecutiveStopsForLocation++;

        // console.log("num consecutive stops", numConsecutiveStopsForLocation);

        markerInstances[currentStopKey] = markerInstances[currentStopKey]
          ? markerInstances[currentStopKey] + 1
          : 1;
        uniqueConsecutiveDestinationsWithInfo.push({
          key: currentStopKey + "-" + markerInstances[currentStopKey],
          locationKey: currentStopKey,
          name: currentStop.customerName,
          destination: currentStopAddressString,
          numOrders: numConsecutiveStopsForLocation,
        });
      }

      //If we are optimizing, we can group up all orders going to the same place to save cost by sending less intermediates
      //as well as make it so we don't have to recalculate stop numbers based on the grouping sent back to us afterwards.
      if (shouldOptimize) {
        const uniqueDestinationsWithInfo = selectedPosition?.stops.reduce(
          (uniqueDestinationInfoBuilder, currentStop) => {
            const stopAddressKey = generateLocationKey(currentStop);
            if (uniqueDestinationInfoBuilder[stopAddressKey]) {
              const destinationWithInfo =
                uniqueDestinationInfoBuilder[stopAddressKey];
              uniqueDestinationInfoBuilder[stopAddressKey] = {
                ...destinationWithInfo,
                numOrders: destinationWithInfo.numOrders + 1,
              };
            } else {
              uniqueDestinationInfoBuilder[stopAddressKey] = {
                key: stopAddressKey + "-" + "1",
                locationKey: stopAddressKey,
                name: currentStop.customerName,
                destination: generateLocationString(currentStop),
                numOrders: 1,
              };
            }
            return uniqueDestinationInfoBuilder;
          },
          [],
        );
        uniqueConsecutiveDestinationsWithInfo = Object.values(
          uniqueDestinationsWithInfo,
        );
      }

      // console.log("marker instances", markerInstances);
      // console.log(
      // "consecutive destinations",
      // uniqueConsecutiveDestinationsWithInfo
      // );
      // console.log("unique destinations with info", uniqueDestinationsWithInfo);

      // const uniqueDestinationsWithInfoEntries = Object.entries(
      //   uniqueDestinationsWithInfo
      // );
      const intermediatesToSend = uniqueConsecutiveDestinationsWithInfo.map(
        (destinationWithInfoEntry) => {
          return { address: destinationWithInfoEntry.destination };
        },
      );

      //Note that optimizedIntermediateWaypointIndex will not be returned if 0 intermediates were sent, and if 1 was sent it will be given index -1 (may result in weird behavior/errors if you don't take into account), that is why shouldActuallyOptimize is based on there being more than 1 intermediate.
      const shouldActuallyOptimize =
        shouldOptimize &&
        (finishLoopBackToClient
          ? intermediatesToSend.length > 1 //only optimize if there is more than 1 intermediate
          : intermediatesToSend.length > 2); //if not finishing the loop back to client, we shift the last intermediate to be the destination, so need to make sure there are more than 2 instead.
      if (intermediatesToSend.length > 25) {
        toast.error("Routing disabled for routes with over 25 stops.");
        return;
      }
      // console.log("should actually optimize", shouldActuallyOptimize);
      // console.log("intermediates to send", intermediatesToSend);

      // console.log(shouldOptimize);
      // return;
      // console.log("CLIENT LOCATION", clientLocation);
      try {
        const routingRequestBody = {
          origin: {
            address: generateLocationString(clientLocation),
          },
          destination: finishLoopBackToClient
            ? { address: generateLocationString(clientLocation) }
            : intermediatesToSend[intermediatesToSend.length - 1],
          //Google maps compute routes v2 api intricacies
          //if the address is completely wrong it will (silently?) give an estimated location based on zip code
          //if the address has a small typo it will (silently?) autocorrect it and give the location based on the correction. The corrected address does not seem to be returned.
          intermediates: finishLoopBackToClient
            ? intermediatesToSend
            : intermediatesToSend.slice(0, -1),
          //  [
          //   { address: "143-105 Tidwell Rd, Houston, TX 77022" },
          //   // { address: "152 Notarealplace Rd, Houston, TX 77034" }, // Gives back an estimated location based on zip code, don't think it gives any indicator that it couldn't find the actual location
          //   { address: "14221 East Sam Houston Parkway N, Houston, TX 77044" }, //
          //   { address: "N Loop E Fwy, Houston, TX 77009" },
          //   { address: "9771-9743 Mesa Dr, Houston, TX 77078" },
          // ],
          travelMode: "DRIVE",
          optimizeWaypointOrder: shouldActuallyOptimize,
          routeModifiers: {
            avoidTolls: false,
            // avoidHighways: true,
          },
        };
        const responseUnparsed = await getMapRouteEP(routingRequestBody);
        const responseData = await JSON.parse(responseUnparsed.data);
        // const response = await mapsApiAxios.post(
        //   "https://routes.googleapis.com/directions/v2:computeRoutes",
        //   routingRequestBody,
        //   {
        //     headers: {
        //       "X-Goog-Api-Key": apizk,
        //       "X-Goog-FieldMask":
        //         "routes,geocodingResults.intermediates.intermediateWaypointRequestIndex,routes.optimizedIntermediateWaypointIndex",
        //     },
        //   }
        // );

        // console.log("intermediates sent", intermediatesToSend);
        // console.log("route and optimization response", responseData);
        let destinationsWithOptimizedWaypointIndex;
        // console.log(uniqueConsecutiveDestinationsWithInfo);
        if (shouldActuallyOptimize) {
          // console.log(
          //   "optimized waypoint order",
          //   responseData?.routes?.[0].optimizedIntermediateWaypointIndex
          // );
          destinationsWithOptimizedWaypointIndex =
            uniqueConsecutiveDestinationsWithInfo.reduce(
              (
                destinationsWithOptimizedWaypointIndexBuilder,
                currentDestinationEntry,
                index,
              ) => {
                return {
                  ...destinationsWithOptimizedWaypointIndexBuilder,
                  [currentDestinationEntry.locationKey]: finishLoopBackToClient
                    ? responseData?.routes?.[0].optimizedIntermediateWaypointIndex.findIndex(
                        (optimizedIndex) => optimizedIndex === index,
                      )
                    : index === uniqueConsecutiveDestinationsWithInfo.length - 1
                      ? index
                      : responseData?.routes?.[0].optimizedIntermediateWaypointIndex.findIndex(
                          (optimizedIndex) => optimizedIndex === index,
                        ),
                };
              },
              {},
            );
          setPositions((prevPositions) => {
            return prevPositions.map((position) => {
              if (position.positionID === selectedPositionID) {
                // const originalStopKeys = position.stops.map((stop) => {
                // return generateLocationKey(stop);
                // });
                // console.log("reorder test - stop keys", originalStopKeys);
                // originalStopKeys.map((stopKey) => {
                // console.log(
                //   "reorder test - unique destinations",
                //   uniqueDestinationsWithInfo
                // );
                // console.log(
                //   `reorder test - stop key ${stopKey} should be moved to ${destinationsWithOptimizedWaypointIndex[stopKey]}`
                // );
                // });
                return {
                  ...position,
                  stops: position.stops.sort((a, b) => {
                    return (
                      destinationsWithOptimizedWaypointIndex[
                        generateLocationKey(a)
                      ] -
                      destinationsWithOptimizedWaypointIndex[
                        generateLocationKey(b)
                      ]
                    );
                  }),
                };
              } else {
                return position;
              }
            });
          });
        }

        // console.log(
        //   "unique destinations with info entries",
        //   uniqueDestinationsWithInfoEntries
        // );

        // console.log(response.data);
        //Can probably derive this data from the route in positionMapCache instead of setting it in it's own state here.
        //Also probably could move all this data including the position map cache to be part of the stop in the stops array of each position as well
        const markers = responseData?.routes?.[0]?.legs?.reduce(
          (markersBuilder, leg, index) => {
            // const relatedStopKey = generateLocationKey(
            //   uniqueDestinationsWithInfoEntries[index][opti]
            // );
            //if we are finishing the loop back to the client's location, ignore the last stop marker as it already has one at the origin (since we are looking at the leg end's. If we were looking at leg starts it would be the first location instead.)
            if (
              finishLoopBackToClient &&
              index === responseData?.routes[0].legs.length - 1
            ) {
              return markersBuilder;
            }
            // if (shouldOptimize) {
            // console.log(
            //   "optimization Issue uniquedestinationswithInfoEntries",
            //   uniqueDestinationsWithInfoEntries[
            //     responseData?.routes?.[0].optimizedIntermediateWaypointIndex[
            //       index
            //     ]
            //   ]
            // );
            // }
            const indexOfDestination = shouldActuallyOptimize
              ? (responseData?.routes?.[0]
                  ?.optimizedIntermediateWaypointIndex?.[index] ?? index) //if not finishing the loopback to the client we will be index out of bound here, so just return the regular index. Also note that optimizedIntermediateWaypointIndex will not be returned if 0 intermediates were sent, and if 1 was sent it will be given index -1 (may result in weird behavior/errors if you don't take into account), that is why shouldActuallyOptimize is based on there being more than 1 intermediate.
              : index;

            //The last destination (or the first if we were using startLocations) has the location info for the client's location
            const legEndCoord = leg.endLocation.latLng;
            return [
              ...markersBuilder,
              {
                key: uniqueConsecutiveDestinationsWithInfo[indexOfDestination]
                  ?.key,
                locationKey:
                  uniqueConsecutiveDestinationsWithInfo[indexOfDestination]
                    ?.locationKey,
                glyph: index + 1,
                location: {
                  lat:
                    legEndCoord.latitude +
                    randomFloatBetween(-0.00005, 0.00005), //small workaround to prevent markers from completely overlapping when their are nonconsecutive stops going to the same location.
                  lng:
                    legEndCoord.longitude +
                    randomFloatBetween(-0.00005, 0.00005), //eventually want to switch to clustering the markers and displaying that their will be multiple stops, with X amount of orders each. (If we want to continue to use this workaround, may want to find a way to decrease the random offset as we zoom in, and increase as we zoom out.)
                },
                size: randomFloatBetween(1.2, 1.3),
                assigned: true,
                data: {
                  name: uniqueConsecutiveDestinationsWithInfo[
                    indexOfDestination
                  ]?.name,
                  address:
                    uniqueConsecutiveDestinationsWithInfo[indexOfDestination]
                      ?.destination,
                  numOrders:
                    uniqueConsecutiveDestinationsWithInfo[indexOfDestination]
                      ?.numOrders,
                },
              },
            ];
          },
          [],
        );

        // console.log(
        //   "optimization issue optimized waypoint index",
        //   destinationsWithOptimizedWaypointIndex
        // );
        // console.log("optimization issue markers", markers);
        const route = responseData?.routes[0];
        const mergedLegs = route?.legs?.map((leg, index) => {
          return {
            ...leg,
            status:
              positionMapCache?.[selectedPositionID]?.route?.legs?.[index]
                ?.status ?? null,
          };
        });
        // if(positionMapCache[selectedPosition]?.route?.legs?.length > 0){
        //   let mergedLegs =[]
        //   for(let i = 0; i<route.legs.length;i++){
        //   positionMapCache[selectedPosition]?.route?.leg[0]

        //   }
        // }
        const mergedRoute = { ...route, legs: mergedLegs };
        setPositionMapCache((prev) => {
          return {
            ...prev,
            [selectedPositionID]: {
              markers: markers,
              route: mergedRoute,
              dirty: false, // this field let's us know we have to fetch the map route for when we move an order or stop to a driver directly. Resetting this to false as we get the route for it here.
            },
          };
        });
      } catch (ex) {
        // console.log(ex);
        toast.error("An error occurred.\n" + ex);
      }
    },
    [selectedPosition, setPositions, setPositionMapCache],
  );
  // console.log("position map cache", positionMapCache);

  // const debouncedGetMapRoutes = useCallback(debounce(getMapRoutes, 2000), [
  //   getMapRoutes,
  // ]);
  // Shortcut to making map live but switching to just calling it on the events that should trigger it
  // useEffect(() => {
  //   // console.log("REROUTED BASED ON DRIVERS");
  //   // console.log("get map routes ran");
  //   getMapRoutes(false);
  // }, [positions]);

  //Got this working with the caveat it reruns whenever selectedPosition is changed. Still reduces calls a lot when reordering stops.
  //Might switch to only calling getMapRoutes on the appropriate events with possibly different delays for each. I.e. stops reorder should probably have a longer delay than add/remove
  //That way we save calls, it still feels quick for adding/removing, and it is only ever possibly be called when it SHOULD.
  // useDebounceEffect(
  //   () => {
  //     // console.log("REROUTED BASED ON DRIVERS");
  //     // console.log("get map routes ran");
  //     getMapRoutes(false);
  //   },
  //   [getMapRoutes],
  //   [positions],
  //   400
  // );

  // //When switching to a different driver, if the positionMapCache for that position is dirty (it was altered without being selected, i.e. orders/stops were dragged directly into it)
  // //fetch the route
  // useDebounceEffect(
  //   () => {
  //     if (selectedPositionID && positionMapCache[selectedPositionID]?.dirty) {
  //       getMapRoutes(false);
  //     }
  //   },
  //   [getMapRoutes],
  //   [selectedPositionID],
  //   400
  // );

  //Previously, both the above were needed to account for updating the map when orders were rearranged as well as for switching positions when they were out of date (due to assigning to them directly without having them selected)
  //But switched to this pseudo event based system
  //Any place/time that should run the logic, updates the notifier state and triggers the logic to run
  const [mapUpdateNotifier, setMapUpdateNotifier] = useState(0);
  useDebounceEffect(
    () => {
      // console.log("ran");
      getMapRoutes(false);
    },
    [getMapRoutes],
    [mapUpdateNotifier],
    400,
  );

  // console.log("simple route test", simpleRouteTest);
  // useEffect(() => {
  //   const sendRouteOptimizationRequest = async () => {
  //     try {
  //       const exampleRequestBody = {
  //         origin: {
  //           address: "9200 Derrington Road Houston, TX 77044",
  //         },
  //         destination: {
  //           address: "9200 Derrington Road Houston, TX 77044",
  //         },
  //         intermediates: [
  //           { address: "14221 East Sam Houston Parkway N, Houston, TX 77044" },
  //           { address: "14221 East Sam Houston Parkway N, Houston, TX 77044" },
  //           { address: "14221 East Sam Houston Parkway N, Houston, TX 77044" },
  //         ],
  //         travelMode: "DRIVE",
  //         optimizeWaypointOrder: "true",
  //       };
  //       const response = await axios.post(
  //         "https://routes.googleapis.com/directions/v2:computeRoutes",
  //         exampleRequestBody,
  //         {
  //           headers: {
  //             "X-Goog-Api-Key": apizk,
  //             "X-Goog-FieldMask":
  //               "routes,geocodingResults.intermediates.intermediateWaypointRequestIndex",
  //           },
  //         }
  //       );
  //       console.log(response);
  //     } catch (ex) {
  //       console.log(ex);
  //     }
  //   };
  //   sendRouteOptimizationRequest();
  // }, []);

  const [showEditDestinationModal, setShowEditDestinationModal] = useState();
  const [orderToEdit, setOrderToEdit] = useState();
  const handleClickEditDestination = (order, orderIsAssigned) => {
    setOrderToEdit(order);
    setShowEditDestinationModal(true);
  };
  const handleCloseEditDestinationModal = () => {
    setShowEditDestinationModal(false);
  };
  const handleSubmitNewOrderDestination = async (orderID, newValues) => {
    //update order
    try {
      //new values from EditCDKDispatchDestinationModal structure:
      //customerName: order?.customerName ?? "",
      //address: order?.address ?? "",
      //city: CapitalizeFirstLetters(order?.city) ?? "",
      //state: order?.state ?? "",
      //zip: order?.zip ?? "",
      await UpdateCdkOrderInformation(
        orderID,
        newValues.address,
        `${newValues.city} ${newValues.state} ${newValues.zip}`,
        newValues.customerName,
      );
      setOrders((prev) => {
        return prev.map((prevOrder) => {
          if (prevOrder.deliveryId === orderID) {
            return {
              ...prevOrder,
              ...newValues,
              locationKey: generateLocationKey(newValues),
              locationString: generateLocationString(newValues),
              locationStringWithoutName: generateLocationString(
                newValues,
                false,
              ),
            }; //works as long as the field names to update are the same between the original and newValues
          } else {
            return prevOrder;
          }
        });
      });
      setShowEditDestinationModal(false);
    } catch (ex) {
      toast.error(
        `Failed to update ${orderTermLowerCase} information.\n${ex}\nPlease try again.`,
      );
    }
  };
  const overlayRef = useRef();
  // console.log("assigned to divider ---------------------------------------");
  // orders.map((order) => {
  //   // console.log(
  //   //   "assigned to (order) - ",
  //   //   order.deliveryId + " | " + order.assignedTo
  //   // );
  // });
  // positions.map((position) => {
  //   position.stops.map((stop) => [
  //     // console.log(
  //     //   "assigned to (stop)",
  //     //   position.positionName +
  //     //     " | " +
  //     //     stop.deliveryId +
  //     //     " | " +
  //     //     stop.assignedTo
  //     // ),
  //   ]);
  // });
  // renderCount++;
  // console.log(renderCount);

  const handlePrintManifestClick = async (e, position) => {
    try {
      const positionToPrintManifestFor = position ? position : selectedPosition;
      // console.log("print manifest test position", position);
      const routeTotals = getRouteTotalDurationAndDistance(
        positionMapCache?.[positionToPrintManifestFor?.positionID]?.route,
      );
      const response = await printManifestForPosition(
        positionToPrintManifestFor.positionID,
        positionToPrintManifestFor.stops.length,
        Math.round(routeTotals.distance),
        `${routeTotals.duration.hours} hr ${routeTotals.duration.minutes} min`,
      );
      fileDownload(
        response.data,
        `${positionToPrintManifestFor.positionName} Manifest - ${dateFormat(
          today,
          "yyyy-MM-dd",
        )}.pdf`,
      );
    } catch (ex) {
      const errorText = await ex.response.data.text(); //Since the response type is blob, if there is an error we need to convert it to text
      // toast.error("An error Occurred\n" + ex);
      // console.log("Exception", ex);
      handleApiError(errorText);
    }
  };

  const [showSwitchingDriverWarning, setShowSwitchingDriverWarning] =
    useState(false);
  const [confirmSwitchDriverCallback, setConfirmSwitchDriverCallback] =
    useState(null);

  const handleCloseSwitchDriverWarning = () => {
    setShowSwitchingDriverWarning(false);
    setConfirmSwitchDriverCallback(null);
  };
  const initiateSwitchDriver = (callBack, positionIDToSwitchTo) => {
    setShowSwitchingDriverWarning(true);
    const finalCallback = () => {
      callBack();
      handleCloseSwitchDriverWarning();
      setSelectedPositionID(positionIDToSwitchTo);
    };
    setConfirmSwitchDriverCallback(() => finalCallback); //when passing a function into setState, it runs the function and sets the state to be the return value of that function. So instead of passing in the callback directly, we wrap it in another function that returns the callback
  };

  return (
    // render jsx
    <>
      <HelmetUtil title="Dispatch" />
      {/* <div
        style={{
          position: "absolute",
          bottom: "70px",
          left: "30px",
        }}
      >
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleClickSimulateRoute}
        >
          Simulate Route
        </button>

        <button
          type="button"
          className="btn btn-primary ml-2"
          onClick={() => {
            setReadOnly((prev) => !prev);
          }}
        >
          Toggle Read Only
        </button>
      </div> */}
      {!(currentViewStates.overall === viewStates.loading) && (
        <>
          <DedicatedOrderDetails
            orderTerminology={orderTerminology}
            order={orderToShowDetailsFor}
            show={showDetailsModal}
            onClose={handleCloseDetailsModal}
            position={
              orderToShowDetailsFor?.assignedTo ? selectedPosition : null
            }
          />
          <SwitchingDriverConfirmationModal
            orderTerminology={orderTerminology}
            positionTerminology={positionTerminology}
            show={showSwitchingDriverWarning}
            onClose={handleCloseSwitchDriverWarning}
            confirmSwitchDriver={confirmSwitchDriverCallback}
          />
          <AddManualDedicatedStopModal
            show={showAddManualStopModal}
            onClose={handleCloseAddManualStopModal}
            stops={selectedPosition?.stops}
            positionHasDepartedHelper={determinePositionHasDeparted}
            defaultState={clientLocation?.state?.toUpperCase()}
            handleAddManualStop={handleAssignOrdersToPosition}
            manualOrderCount={manualOrderCount}
            setManualOrderCount={setManualOrderCount}
          />
          <EditCDKDispatchDestinationModal
            show={showEditDestinationModal}
            onHide={handleCloseEditDestinationModal}
            order={orderToEdit}
            originalCDKData={orderToEdit?.originalData}
            onSubmitNewDestination={handleSubmitNewOrderDestination}
          />
        </>
      )}
      {/* <div className="panel-flat p-2 px-3 mb-2 d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Dedicated Dispatch</h4>
        <div className="d-flex gap-3 align-items-center">
          <BsGearFill size={20} />
        </div>
      </div> */}
      {/* <div className="panel-flatz py-2 px-1 mb-2 d-flex justify-content-between align-items-center">
        <h3 className="mb-0">Dedicated Dispatch</h3>
        <div className="d-flex gap-3 align-items-center">
          <BsGearFill size={25} />
        </div>
      </div> */}
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={handleDragStart}
        onDragCancel={handleDragCancel}
        onDragAbort={handleDragCancel}
        onDragOver={handleDragOver}
        onDragEnd={handleDragEnd}
      >
        <div className="dedicated-dispatch-main-container">
          <div
            className="dedicated-dispatch-list-container panel-flat"
            style={{
              flex: collapsedStatePanelSizes.orders[collapsedState],
            }}
          >
            {/* <div
            className="tw-overflow-auto tw-max-h-136"
            // style={{ backgroundColor: "rgb(240,242,245)", padding: ".5rem" }} // other design
          > */}
            {collapsedState === collapsedStates.map.value ? (
              <div
                className="text-note"
                style={{
                  display: "grid",
                  height: "100%",
                  placeContent: "center",
                }}
              >
                <PiPackage size={35} />
              </div>
            ) : (
              <OrdersDropzoneAndHeader
                onOrderMouseEnter={(e, stopId) => {
                  setHoveredStop(stopId);
                }}
                onOrderMouseLeave={(e, stopId) => {
                  setHoveredStop(stopId);
                }}
                orderTerminology={orderTerminology}
                orders={orders}
                readOnly={readOnly}
                position={selectedPosition}
                orderOnClick={orderOnClick}
                onAssignOrderClick={onAssignOrderClick}
                onDetailsClick={handleShowDetailsModal}
                onEditDestinationClick={handleClickEditDestination}
                draggingData={draggingData}
                selectedOrderIDs={selectedOrderIDs}
                refetchOrders={fetchNewOrdersAndStatusUpdates}
                isLoadingOrders={
                  currentViewStates.orders === viewStates.loading
                }
                failedGeolocationsLookupObj={
                  viewUnassignedData.failedGeolocationsLookupObj
                }
                completeNextOrderTestFunction={completeNextOrderTestFunction}
              />
            )}
          </div>
          <div
            className="dedicated-dispatch-list-container panel-flat"
            style={{
              flex: collapsedStatePanelSizes.positions[collapsedState],
            }}
          >
            {collapsedState === collapsedStates.map.value ? (
              <div
                className="text-note"
                style={{
                  display: "grid",
                  height: "100%",
                  placeContent: "center",
                }}
              >
                <PiPersonSimpleBike size={35} />
              </div>
            ) : (
              <PositionDropzoneAndHeader
                positionTerminology={positionTerminology}
                positions={positions}
                selectedPositionID={selectedPositionID}
                handleSelectPositionID={handleSelectPositionID}
                handlePrintManifestClick={handlePrintManifestClick}
                draggingData={draggingData}
                disabled={draggingData?.isDraggingManualOrder}
                switchDriverCache={switchDriverCache}
                isLoadingPositions={
                  currentViewStates.positions === viewStates.loading
                }
              />
            )}
          </div>
          <CollapseButton
            collapsedState={collapsedState}
            setCollapsedState={setCollapsedState}
          />
          <div
            className="dedicated-dispatch-list-container panel-flat"
            style={{ flex: collapsedStatePanelSizes.stops[collapsedState] }}
          >
            {collapsedState === collapsedStates.lists.value ? (
              <div
                className="text-note"
                style={{
                  display: "grid",
                  height: "100%",
                  placeContent: "center",
                }}
              >
                <div>
                  <PiPackage size={35} />
                  <PiPersonSimpleBike size={35} />
                </div>
              </div>
            ) : (
              <>
                <DispatchBoardHeader
                  title={
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: ".4rem",
                        }}
                      >
                        Stops
                      </div>
                    </>
                  }
                  headerContent={
                    !readOnly &&
                    selectedPositionID && (
                      <div className="text-right">
                        <button
                          type="button"
                          title="Submission disabled for demo account."
                          className="btn btn-primary"
                          disabled={
                            selectedPositionHasOrdersBeingSwitched
                            // || isDemoAccountBool //just made it so it doesn't actually send the api requests if demo account.
                          }
                          onClick={handleSubmitOrdersForPosition}
                        >
                          Submit
                        </button>
                        <Dropdown
                          // title="Actions"
                          style={{ display: "inline-block", marginLeft: "5px" }}
                        >
                          <Dropdown.Toggle
                            as={CustomDropdownToggle}
                            id="stopActions"
                          >
                            <BsThreeDotsVertical
                              title="Actions"
                              size={25}
                              className="tw-cursor-pointer"
                              style={{ marginRight: "-5px" }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              as="button"
                              type="button"
                              className="py-2"
                              onClick={handlePrintManifestClick}
                              disabled={!selectedPosition?.wasSubmitted}
                            >
                              Print Manifest
                            </Dropdown.Item>
                            <Dropdown.Item
                              as="button"
                              type="button"
                              className="py-2"
                              onClick={handleShowAddManualStopModal}
                            >
                              Add Manual Stop
                            </Dropdown.Item>
                            <OverlayTrigger
                              key="group-reorder"
                              flip
                              placement="right"
                              overlay={
                                <TooltipStandard id="group-reoorder-tooltip">
                                  Orders will be re-sequenced so that all orders
                                  going to the same place are together. Based on
                                  the first instance found of each destination.
                                </TooltipStandard>
                              }
                            >
                              <Dropdown.Item
                                as="button"
                                type="button"
                                className="py-2"
                                disabled={selectedPosition.wasSubmitted}
                                onClick={() => {
                                  setPositions((prev) => {
                                    return prev.map((driver) => {
                                      if (
                                        driver.positionID === selectedPositionID
                                      ) {
                                        const orderOfStopsByUniqueDestination =
                                          driver.stops.reduce(
                                            (rolling, currentStop) => {
                                              const groupAccessor =
                                                currentStop.address +
                                                currentStop.city +
                                                currentStop.state +
                                                currentStop.zip;
                                              if (rolling[groupAccessor]) {
                                                rolling[groupAccessor] = [
                                                  ...rolling[groupAccessor],
                                                  currentStop,
                                                ];
                                              } else {
                                                rolling[groupAccessor] = [
                                                  currentStop,
                                                ];
                                              }
                                              return rolling;
                                            },
                                            {},
                                          );
                                        const destinationOrderedStops =
                                          Object.values(
                                            orderOfStopsByUniqueDestination,
                                          ).reduce((rolling, current) => {
                                            const rollingAppend = [
                                              ...rolling,
                                              ...current,
                                            ];
                                            return rollingAppend;
                                          }, []);
                                        // console.log(orderOfStopsByUniqueDestination);
                                        return {
                                          ...driver,
                                          stops: destinationOrderedStops,
                                        };
                                      } else {
                                        return driver;
                                      }
                                    });
                                  });
                                }}
                              >
                                Group
                              </Dropdown.Item>
                            </OverlayTrigger>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )
                  }
                ></DispatchBoardHeader>
                <StopsDropzone
                  positionTerminology={positionTerminology}
                  stops={selectedPosition?.stops}
                  readOnly={readOnly}
                  position={selectedPosition}
                  unAssignStop={unAssignStop}
                  onDetailsClick={handleShowDetailsModal}
                  onStopMouseEnter={(e, stopId) => {
                    setHoveredStop(stopId);
                  }}
                  onStopMouseLeave={(e, stopId) => {
                    setHoveredStop(stopId);
                  }}
                  selectedPositionID={selectedPositionID}
                  selectedOrderIDs={selectedOrderIDs}
                  selectedPositionRunsToday={determinePositionRunsOnCurrentDay(
                    selectedPosition,
                  )}
                  overlayRef={overlayRef}
                  draggingData={draggingData}
                  onEditDestinationClick={handleClickEditDestination}
                  handleShowAddStopManuallyModal={handleShowAddManualStopModal}
                  switchDriverCache={switchDriverCache}
                  completeStopTestFunction={completeStopTestFunction}
                  indexToPhysicalStopNumberMap={
                    physicalStopData?.indexToPhysicalStopNumberMap
                  }
                  latestCompletedOrderPhysicalStopNumber={
                    physicalStopData?.latestCompletedOrderPhysicalStopNumber
                  }
                />
              </>
            )}
          </div>
          <div
            style={{
              border: "1px solid rgb(0,0,0,.2)",
              borderRadius: "5px",
              padding: "1rem",
              flex: collapsedStatePanelSizes.map[collapsedState],
              transitionDuration: ".5s",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {collapsedState === collapsedStates.lists.value ? (
              <div
                className="text-note"
                style={{
                  display: "grid",
                  height: "100%",
                  placeContent: "center",
                }}
              >
                <PiMapPinAreaFill size={35} />
              </div>
            ) : (
              <>
                <div className="d-flex mb-3 justify-content-between align-items-start">
                  <h4>Route Planning</h4>
                  <div className="d-flex gap-4 align-items-start justify-content end">
                    {/* <button
                  className="btn btn-primary mb-2"
                  onClick={() => {
                    getMapRoutes(false);
                  }}
                >
                  Route
                </button> */}

                    {/* <button
                className="btn btn-primary"
                onClick={() => {
                  setShowSimpleRoute((prev) => !prev);
                }}
              >
                {showSimpleRoute ? "Viewing Simple" : "Viewing Complex"}
              </button> */}
                    <div
                      className="btn-group font-600 text-note"
                      style={{
                        borderRadius: ".25rem",
                        boxShadow: "0px 0px 7px rgb(0,0,0,.2)",
                      }}
                    >
                      <button
                        type="button"
                        className={
                          "btn" +
                          (showSimpleRoute ? " btn-group-btn-active" : "")
                        }
                        onClick={() => {
                          setShowSimpleRoute(true);
                        }}
                      >
                        Simple
                        {/* <BsCardList /> */}
                      </button>

                      <button
                        type="button"
                        className={
                          "btn" +
                          (!showSimpleRoute ? " btn-group-btn-active" : "")
                        }
                        onClick={() => {
                          setShowSimpleRoute(false);
                        }}
                      >
                        Complex
                        {/* <BsList /> */}
                      </button>
                    </div>
                    {!readOnly && (
                      <button
                        disabled={
                          !selectedPositionID ||
                          selectedPosition.stops < 1 ||
                          selectedPosition.wasSubmitted
                        }
                        className="btn btn-primary mb-2"
                        onClick={() => {
                          getMapRoutes(true);
                        }}
                      >
                        Optimize
                      </button>
                    )}
                    <ToggleSwitch
                      label="View Unassigned"
                      onClick={handleClickViewUnassigned}
                      checked={viewUnassigned}
                    />
                  </div>
                  {/* <button
                type="button"
                className="btn btn-primary"
                onClick={handleClickViewUnassigned}
              >
                View Unassigned
              </button> */}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                  }}
                >
                  <DiliMap
                    mapRef={mapRef}
                    initialCenterCoord={clientCoordinates}
                    assignOrders={handleAssignOrdersToPosition}
                    markers={[
                      {
                        key: "base",
                        glyph: <PiHouseFill />,
                        location: clientCoordinates,
                        data: {
                          name: clientLocation?.name,
                          address: clientLocation
                            ? generateLocationString(clientLocation)
                            : "Loading",
                        },
                      },
                      ...(viewUnassigned
                        ? (viewUnassignedData?.destinationMarkers ?? [])
                        : []),
                      ...(positionMapCache[selectedPositionID]?.markers ?? []),
                    ]}
                    // hoveredMarker={
                    //   (testState % selectedPosition.stops.length) + 1
                    // }
                    hoveredMarker={hoveredStop}
                    route={positionMapCache[selectedPositionID]?.route}
                    legStatuses={physicalStopData?.routeLegStatuses} //status can be embedded into each leg object or passed separately
                    simpleRoute={showSimpleRoute}
                    apiKey={mapApiKey}
                    showDrawToAssignButton={
                      selectedPositionID &&
                      determinePositionRunsOnCurrentDay(selectedPosition) &&
                      viewUnassigned
                    }
                  />
                  <div>
                    <div
                      style={{
                        fontWeight: 900,
                      }}
                      className="text-note justify-content-center mt-2 d-flex"
                    >
                      <div className="mr-2">Estimated Distance</div>
                      <div className="text-center mr-4">
                        {routeTotalDurationAndDistance.distance} mile(s)
                      </div>

                      <div className="mr-2">Estimated Time</div>
                      <div className="text-center">
                        {routeTotalDurationAndDistance.duration.hours}H{" "}
                        {routeTotalDurationAndDistance.duration.minutes}M
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        {/* {console.log("dragging data", draggingData.id)} */}
        <DragOverlay>
          {draggingData.id != null ? (
            <div
              className="drag-overlay-inner-container drag-item"
              style={
                {
                  // scale: draggingData.id != null ? 1.5 : 1,
                  // transform: draggingData.id != null ? "scale(1.5)" : "scale(1)",
                  // transition: "all 500ms",
                }
              }
            >
              <Order
                reftest={overlayRef}
                order={orderToDisplayForDragOverlay}
                isOverlay
                selectedOrderIDs={selectedOrderIDs}
                draggingData={draggingData}
                position={selectedPosition}
                stopNumber={draggingData.stopNumber}
                physicalStopNumber={
                  draggingData.physicalStopNumber
                  // selectedPositionID
                  //   ? positions
                  //       .find((driver) => {
                  //         return selectedPositionID === driver.positionID;
                  //       })
                  //       .stops.findIndex((stop) => {
                  //         return stop.deliveryId === draggingData.id;
                  //       }) !== -1
                  //     ? positions
                  //         .find((driver) => {
                  //           return selectedPositionID === driver.positionID;
                  //         })
                  //         .stops.findIndex((stop) => {
                  //           return stop.deliveryId === draggingData.id;
                  //         }) + 1
                  //     : undefined
                  //   : undefined
                }
              />
            </div>
          ) : null}
        </DragOverlay>
      </DndContext>
      {/* <CollapsibleUITest />
      <CollapsibleUITestWithContent /> */}
    </>
  );
};
